import { gql } from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Decimal: { input: any; output: any; }
  Int64: { input: any; output: any; }
  Time: { input: any; output: any; }
  UUID: { input: any; output: any; }
  openfed__Scope: { input: any; output: any; }
};

export type Branch = {
  __typename?: 'Branch';
  branchID: Scalars['UUID']['output'];
};

export enum ConsignmentChangeHistoryAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  Import = 'IMPORT',
  Update = 'UPDATE'
}

export type ConsignmentChangeHistoryActor = {
  __typename?: 'ConsignmentChangeHistoryActor';
  userID: Scalars['UUID']['output'];
  userName: Scalars['String']['output'];
};

export type ConsignmentChangeHistoryActorPaged = {
  __typename?: 'ConsignmentChangeHistoryActorPaged';
  items: Array<ConsignmentChangeHistoryActor>;
  pagination: PaginationResult;
};

export type ConsignmentChangeHistoryActorQopFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ConsignmentChangeHistoryActorQopInput = {
  filters?: InputMaybe<ConsignmentChangeHistoryActorQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
};

export enum ConsignmentChangeHistoryArea {
  Contract = 'CONTRACT',
  Curation = 'CURATION',
  Deadlines = 'DEADLINES',
  Registration = 'REGISTRATION',
  StoresTeams = 'STORES_TEAMS'
}

export type ConsignmentChangeHistoryEntry = {
  __typename?: 'ConsignmentChangeHistoryEntry';
  action: ConsignmentChangeHistoryAction;
  area: ConsignmentChangeHistoryArea;
  changedAt: Scalars['Time']['output'];
  changedByUserID?: Maybe<Scalars['UUID']['output']>;
  changedByUserName: Scalars['String']['output'];
  consignmentChangeHistoryID: Scalars['UUID']['output'];
  fields: Array<ConsignmentChangeHistoryField>;
  item: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  source: ConsignmentChangeHistorySource;
};

export type ConsignmentChangeHistoryField = {
  __typename?: 'ConsignmentChangeHistoryField';
  after?: Maybe<Scalars['String']['output']>;
  before?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
};

export type ConsignmentChangeHistoryPaged = {
  __typename?: 'ConsignmentChangeHistoryPaged';
  items?: Maybe<Array<ConsignmentChangeHistoryEntry>>;
  pagination: PaginationResult;
};

export type ConsignmentChangeHistoryQopFilterInput = {
  area?: InputMaybe<ConsignmentChangeHistoryArea>;
  changedByUserID?: InputMaybe<Scalars['UUID']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};

export type ConsignmentChangeHistoryQopInput = {
  filters?: InputMaybe<ConsignmentChangeHistoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
};

export enum ConsignmentChangeHistorySource {
  CsvImport = 'CSV_IMPORT',
  Screen = 'SCREEN',
  System = 'SYSTEM'
}

export type ConsignmentCuration = {
  __typename?: 'ConsignmentCuration';
  defaultCommission: ConsignmentSetupIntSetting;
  perishableThresholds: Array<ConsignmentCurationPerishableThreshold>;
  regionMethods: Array<ConsignmentCurationRegionMethod>;
  sampleSendDays: ConsignmentSetupIntSetting;
};

export enum ConsignmentCurationBarcodeCheck {
  Clear = 'CLEAR',
  Failed = 'FAILED',
  NotChecked = 'NOT_CHECKED',
  Taken = 'TAKEN'
}

export type ConsignmentCurationBarcodeHolder = {
  __typename?: 'ConsignmentCurationBarcodeHolder';
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  vendorCode?: Maybe<Scalars['String']['output']>;
  vendorID?: Maybe<Scalars['UUID']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
};

export type ConsignmentCurationBlocker = {
  __typename?: 'ConsignmentCurationBlocker';
  kind: ConsignmentCurationBlockerKind;
  message: Scalars['String']['output'];
  refID?: Maybe<Scalars['UUID']['output']>;
};

export enum ConsignmentCurationBlockerKind {
  AllocatedStoreNotReady = 'ALLOCATED_STORE_NOT_READY',
  ApprovedWithoutStore = 'APPROVED_WITHOUT_STORE',
  ApprovedWithoutSubCategory = 'APPROVED_WITHOUT_SUB_CATEGORY',
  BarcodeNotClear = 'BARCODE_NOT_CLEAR',
  ProductPending = 'PRODUCT_PENDING'
}

export enum ConsignmentCurationCommissionType {
  Default = 'DEFAULT',
  Special = 'SPECIAL'
}

export type ConsignmentCurationLabelNameInput = {
  consignmentRegistrationID: Scalars['UUID']['input'];
  labelName: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export enum ConsignmentCurationMethod {
  PhotoOnly = 'PHOTO_ONLY',
  SampleRequired = 'SAMPLE_REQUIRED'
}

export type ConsignmentCurationPerishableThreshold = {
  __typename?: 'ConsignmentCurationPerishableThreshold';
  canBePerishable: Scalars['Boolean']['output'];
  consignmentCurationPerishableThresholdID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  productType: ConsignmentCurationProductType;
  productTypeName: Scalars['String']['output'];
  shelfLifeUnderDays?: Maybe<Scalars['Int']['output']>;
};

export type ConsignmentCurationPhoto = {
  __typename?: 'ConsignmentCurationPhoto';
  expiresAt: Scalars['Time']['output'];
  isMain: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type ConsignmentCurationProduct = {
  __typename?: 'ConsignmentCurationProduct';
  allocatedStoreIDs: Array<Scalars['UUID']['output']>;
  alsoOnDirectPurchaseProduct: Scalars['Boolean']['output'];
  barcode?: Maybe<Scalars['String']['output']>;
  barcodeCheck: ConsignmentCurationBarcodeCheck;
  barcodeCheckedAt?: Maybe<Scalars['Time']['output']>;
  barcodeHolders: Array<ConsignmentCurationBarcodeHolder>;
  barcodeOverride: Scalars['Boolean']['output'];
  consignmentRegistrationProductID: Scalars['UUID']['output'];
  curationMethod: ConsignmentCurationMethod;
  curationMethodChangedAt?: Maybe<Scalars['Time']['output']>;
  curationMethodChangedByUserName?: Maybe<Scalars['String']['output']>;
  curationMethodLockedAt: Scalars['Time']['output'];
  curationMethodOriginal: ConsignmentCurationMethod;
  curationNearestBranchName?: Maybe<Scalars['String']['output']>;
  curationRegionName?: Maybe<Scalars['String']['output']>;
  decidedAt?: Maybe<Scalars['Time']['output']>;
  decidedByUserName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  halalNumber?: Maybe<Scalars['String']['output']>;
  halalStatus?: Maybe<Scalars['String']['output']>;
  isApproved: Scalars['Boolean']['output'];
  isPerishable: Scalars['Boolean']['output'];
  labelName?: Maybe<Scalars['String']['output']>;
  lineNumber: Scalars['Int']['output'];
  needsPermitCheck: Scalars['Boolean']['output'];
  perishableShelfLifeUnderDays?: Maybe<Scalars['Int']['output']>;
  permitNumber?: Maybe<Scalars['String']['output']>;
  permitType?: Maybe<Scalars['String']['output']>;
  photos: Array<ConsignmentCurationPhoto>;
  productCategoryName: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  productTypeName: Scalars['String']['output'];
  proposedSubCategory?: Maybe<Scalars['String']['output']>;
  rejectNote?: Maybe<Scalars['String']['output']>;
  rejectReason?: Maybe<ConsignmentCurationRejectReason>;
  rejectReasonLabel?: Maybe<Scalars['String']['output']>;
  sampleConditionNote?: Maybe<Scalars['String']['output']>;
  sampleReceived: Scalars['Boolean']['output'];
  sampleReceivedAt?: Maybe<Scalars['Time']['output']>;
  sampleReceivedByUserName?: Maybe<Scalars['String']['output']>;
  sampleShipment?: Maybe<ConsignmentCurationSampleShipment>;
  sampleStatus: ConsignmentCurationSampleStatus;
  sellingPrice: Scalars['Float']['output'];
  shelfLifeDays?: Maybe<Scalars['Int']['output']>;
  storageType: Scalars['String']['output'];
  subCategoryID?: Maybe<Scalars['UUID']['output']>;
  subCategoryName?: Maybe<Scalars['String']['output']>;
  subCategoryOptions: Array<ConsignmentCurationSubCategoryOption>;
  vendorSubCategoryName?: Maybe<Scalars['String']['output']>;
  verdict: ConsignmentCurationVerdict;
  version: Scalars['UUID']['output'];
};

export type ConsignmentCurationProductDecideInput = {
  consignmentRegistrationID: Scalars['UUID']['input'];
  labelName?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  rejectNote?: InputMaybe<Scalars['String']['input']>;
  rejectReason?: InputMaybe<ConsignmentCurationRejectReason>;
  storeIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  subCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  verdict: ConsignmentCurationVerdict;
  version: Scalars['UUID']['input'];
};

export type ConsignmentCurationProductSwitchToPhotoOnlyInput = {
  consignmentRegistrationID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
  version: Scalars['UUID']['input'];
};

export enum ConsignmentCurationProductType {
  Beverages = 'BEVERAGES',
  Food = 'FOOD',
  NonFood = 'NON_FOOD'
}

export type ConsignmentCurationPublishInput = {
  commissionReason?: InputMaybe<Scalars['String']['input']>;
  consignmentRegistrationID: Scalars['UUID']['input'];
  expectedVersion: Scalars['UUID']['input'];
  stores?: InputMaybe<Array<ConsignmentCurationStoreCommissionInput>>;
  vendorNote?: InputMaybe<Scalars['String']['input']>;
};

export type ConsignmentCurationPublishPreview = {
  __typename?: 'ConsignmentCurationPublishPreview';
  approvedProductCount: Scalars['Int']['output'];
  blockers: Array<ConsignmentCurationBlocker>;
  endReason?: Maybe<ConsignmentRegistrationEndReason>;
  reapplyFrom?: Maybe<Scalars['String']['output']>;
  totalProductCount: Scalars['Int']['output'];
  whatsappText?: Maybe<Scalars['String']['output']>;
  willAccept: Scalars['Boolean']['output'];
};

export type ConsignmentCurationPublishedMessage = {
  __typename?: 'ConsignmentCurationPublishedMessage';
  lastErrorCode?: Maybe<ConsignmentWhatsAppSendErrorCode>;
  sentAt?: Maybe<Scalars['Time']['output']>;
  status?: Maybe<ConsignmentWhatsAppSendStatus>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ConsignmentCurationRegionMethod = {
  __typename?: 'ConsignmentCurationRegionMethod';
  consignmentRegionID: Scalars['UUID']['output'];
  curationMethodIsDefault: Scalars['Boolean']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  nonPerishableCurationMethod: ConsignmentCurationMethod;
  perishableCurationMethod: ConsignmentCurationMethod;
  regionName: Scalars['String']['output'];
};

export type ConsignmentCurationRegionMethodChangeInput = {
  consignmentRegionID: Scalars['UUID']['input'];
  nonPerishableCurationMethod: ConsignmentCurationMethod;
  perishableCurationMethod: ConsignmentCurationMethod;
  version: Scalars['UUID']['input'];
};

export enum ConsignmentCurationRejectReason {
  BarcodeTaken = 'BARCODE_TAKEN',
  Brand = 'BRAND',
  Label = 'LABEL',
  Legal = 'LEGAL',
  Other = 'OTHER',
  Overlap = 'OVERLAP',
  Price = 'PRICE',
  Quality = 'QUALITY',
  SampleNotReceived = 'SAMPLE_NOT_RECEIVED',
  Slow = 'SLOW',
  StoreUnavailable = 'STORE_UNAVAILABLE'
}

export type ConsignmentCurationSampleConditionNoteInput = {
  note: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
};

export enum ConsignmentCurationSampleMethod {
  Courier = 'COURIER',
  SelfDelivery = 'SELF_DELIVERY'
}

export type ConsignmentCurationSampleProof = {
  __typename?: 'ConsignmentCurationSampleProof';
  expiresAt: Scalars['Time']['output'];
  mimeType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ConsignmentCurationSampleReceiveInput = {
  conditionNote?: InputMaybe<Scalars['String']['input']>;
  conditionNotes?: InputMaybe<Array<ConsignmentCurationSampleConditionNoteInput>>;
  consignmentRegistrationID: Scalars['UUID']['input'];
  productIDs: Array<Scalars['UUID']['input']>;
};

export type ConsignmentCurationSampleShipment = {
  __typename?: 'ConsignmentCurationSampleShipment';
  method: ConsignmentCurationSampleMethod;
  packageID: Scalars['UUID']['output'];
  photos: Array<ConsignmentCurationSampleProof>;
  qty?: Maybe<Scalars['Int']['output']>;
  shippedAt: Scalars['String']['output'];
  shippedToAddress: Scalars['String']['output'];
  shippedToTeamName: Scalars['String']['output'];
  trackingNo?: Maybe<Scalars['String']['output']>;
};

export enum ConsignmentCurationSampleStatus {
  AwaitingSample = 'AWAITING_SAMPLE',
  InTransit = 'IN_TRANSIT',
  NotRequired = 'NOT_REQUIRED',
  Received = 'RECEIVED'
}

export type ConsignmentCurationStore = {
  __typename?: 'ConsignmentCurationStore';
  activeVendorCount?: Maybe<Scalars['Int']['output']>;
  approvedProductCount: Scalars['Int']['output'];
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  commissionPct?: Maybe<Scalars['Int']['output']>;
  commissionType?: Maybe<ConsignmentCurationCommissionType>;
  consignmentRegistrationStoreID: Scalars['UUID']['output'];
  distanceKm?: Maybe<Scalars['Float']['output']>;
  notReadyReason?: Maybe<Scalars['String']['output']>;
  pendingProductCount: Scalars['Int']['output'];
  ready: Scalars['Boolean']['output'];
  rejectedProductCount: Scalars['Int']['output'];
  result?: Maybe<ConsignmentCurationStoreResult>;
  teamName?: Maybe<Scalars['String']['output']>;
  version: Scalars['UUID']['output'];
};

export type ConsignmentCurationStoreCommissionInput = {
  commissionPct?: InputMaybe<Scalars['Int']['input']>;
  commissionType: ConsignmentCurationCommissionType;
  storeID: Scalars['UUID']['input'];
};

export enum ConsignmentCurationStoreResult {
  Approved = 'APPROVED',
  NotReady = 'NOT_READY',
  NoProduct = 'NO_PRODUCT'
}

export type ConsignmentCurationSubCategoryOption = {
  __typename?: 'ConsignmentCurationSubCategoryOption';
  productCategoryID: Scalars['UUID']['output'];
  productCategoryName: Scalars['String']['output'];
  subCategoryID: Scalars['UUID']['output'];
  subCategoryName: Scalars['String']['output'];
};

export type ConsignmentCurationThresholdChangeInput = {
  canBePerishable: Scalars['Boolean']['input'];
  consignmentCurationPerishableThresholdID: Scalars['UUID']['input'];
  shelfLifeUnderDays?: InputMaybe<Scalars['Int']['input']>;
  version: Scalars['UUID']['input'];
};

export type ConsignmentCurationUpdateInput = {
  defaultCommission?: InputMaybe<ConsignmentSetupIntChangeInput>;
  perishableThresholds?: InputMaybe<Array<ConsignmentCurationThresholdChangeInput>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  regionMethods?: InputMaybe<Array<ConsignmentCurationRegionMethodChangeInput>>;
  sampleSendDays?: InputMaybe<ConsignmentSetupIntChangeInput>;
};

export type ConsignmentCurationUpdateResult = {
  __typename?: 'ConsignmentCurationUpdateResult';
  changed: Scalars['Boolean']['output'];
  curation: ConsignmentCuration;
};

export enum ConsignmentCurationVerdict {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ConsignmentPilotInvite = {
  __typename?: 'ConsignmentPilotInvite';
  businessName: Scalars['String']['output'];
  consignmentPilotInviteID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  phoneNumberMasked: Scalars['String']['output'];
  registrationNumber?: Maybe<Scalars['String']['output']>;
  source: ConsignmentPilotInviteSource;
  status: ConsignmentPilotInviteStatus;
};

export type ConsignmentPilotInviteCreateInput = {
  businessName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type ConsignmentPilotInviteImportInput = {
  rows: Array<ConsignmentPilotInviteImportRowInput>;
};

export type ConsignmentPilotInviteImportPreview = {
  __typename?: 'ConsignmentPilotInviteImportPreview';
  invalidRows: Scalars['Int']['output'];
  rows: Array<ConsignmentPilotInviteImportRow>;
  totalRows: Scalars['Int']['output'];
  validRows: Scalars['Int']['output'];
};

export type ConsignmentPilotInviteImportResult = {
  __typename?: 'ConsignmentPilotInviteImportResult';
  importedRows: Scalars['Int']['output'];
  rows: Array<ConsignmentPilotInviteImportRow>;
  skippedRows: Scalars['Int']['output'];
};

export type ConsignmentPilotInviteImportRow = {
  __typename?: 'ConsignmentPilotInviteImportRow';
  businessName: Scalars['String']['output'];
  phoneNumberMasked?: Maybe<Scalars['String']['output']>;
  reasons: Array<Scalars['String']['output']>;
  rowNumber: Scalars['Int']['output'];
  status: ConsignmentPilotInviteImportRowStatus;
};

export type ConsignmentPilotInviteImportRowInput = {
  businessName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
};

export enum ConsignmentPilotInviteImportRowStatus {
  Imported = 'IMPORTED',
  Invalid = 'INVALID',
  Skipped = 'SKIPPED',
  Valid = 'VALID'
}

export type ConsignmentPilotInvitePaged = {
  __typename?: 'ConsignmentPilotInvitePaged';
  items?: Maybe<Array<ConsignmentPilotInvite>>;
  pagination: PaginationResult;
};

export type ConsignmentPilotInviteQopFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConsignmentPilotInviteStatus>;
};

export type ConsignmentPilotInviteQopInput = {
  filters?: InputMaybe<ConsignmentPilotInviteQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
};

export enum ConsignmentPilotInviteSource {
  Csv = 'CSV',
  Manual = 'MANUAL'
}

export enum ConsignmentPilotInviteStatus {
  Invited = 'INVITED',
  Registered = 'REGISTERED'
}

export type ConsignmentProductRequest = {
  __typename?: 'ConsignmentProductRequest';
  approvedByUserID?: Maybe<Scalars['UUID']['output']>;
  approvedByUserName?: Maybe<Scalars['String']['output']>;
  approvedDatetime?: Maybe<Scalars['Time']['output']>;
  changeReason: Scalars['String']['output'];
  consignmentProductRequestID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  noteReviewer: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID?: Maybe<Scalars['UUID']['output']>;
  productImageFileID?: Maybe<Scalars['UUID']['output']>;
  productImageFileSizeMB: Scalars['Float']['output'];
  productImageLargeURL: Scalars['String']['output'];
  productImageMediumURL: Scalars['String']['output'];
  productImageMimeType: Scalars['String']['output'];
  productImageOriginalFileName: Scalars['String']['output'];
  productImageSmallURL: Scalars['String']['output'];
  productImageStorageBucket: Scalars['String']['output'];
  productImageStoragePath: Scalars['String']['output'];
  proposedBarcode: Scalars['String']['output'];
  proposedCategory: Scalars['String']['output'];
  proposedDescription: Scalars['String']['output'];
  proposedPackaging: Scalars['String']['output'];
  proposedProductName: Scalars['String']['output'];
  proposedSellingPrice: Scalars['Float']['output'];
  proposedShelfLife: Scalars['String']['output'];
  proposedWeightGram: Scalars['Float']['output'];
  rejectedByUserID?: Maybe<Scalars['UUID']['output']>;
  rejectedByUserName?: Maybe<Scalars['String']['output']>;
  rejectedDatetime?: Maybe<Scalars['Time']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  requestCode: Scalars['String']['output'];
  requestDatetime: Scalars['Time']['output'];
  requestDatetimeUtc: Scalars['Time']['output'];
  requestType: Scalars['String']['output'];
  resultProductID?: Maybe<Scalars['UUID']['output']>;
  status: Scalars['String']['output'];
  submittedByUserID?: Maybe<Scalars['UUID']['output']>;
  submittedByUserName?: Maybe<Scalars['String']['output']>;
  submittedDatetime?: Maybe<Scalars['Time']['output']>;
  uniqueKey: Scalars['String']['output'];
  vendorCode: Scalars['String']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
};

export type ConsignmentProductRequestCancelInput = {
  consignmentProductRequestID: Scalars['UUID']['input'];
};

export type ConsignmentProductRequestCreateInput = {
  changeReason?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productImageFileID?: InputMaybe<Scalars['UUID']['input']>;
  proposedBarcode?: InputMaybe<Scalars['String']['input']>;
  proposedCategory?: InputMaybe<Scalars['String']['input']>;
  proposedDescription?: InputMaybe<Scalars['String']['input']>;
  proposedPackaging?: InputMaybe<Scalars['String']['input']>;
  proposedProductName: Scalars['String']['input'];
  proposedSellingPrice?: InputMaybe<Scalars['Float']['input']>;
  proposedShelfLife?: InputMaybe<Scalars['String']['input']>;
  proposedWeightGram?: InputMaybe<Scalars['Float']['input']>;
  requestType: Scalars['String']['input'];
  submit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsignmentProductRequestPaged = {
  __typename?: 'ConsignmentProductRequestPaged';
  items: Array<ConsignmentProductRequest>;
  pagination: PaginationResult;
};

export type ConsignmentProductRequestQopFilterInput = {
  productID?: InputMaybe<Scalars['UUID']['input']>;
  proposedProductName?: InputMaybe<Scalars['String']['input']>;
  requestCode?: InputMaybe<Scalars['String']['input']>;
  requestDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  requestDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  requestType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentProductRequestQopInput = {
  filters?: InputMaybe<ConsignmentProductRequestQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentProductRequestReviewInput = {
  consignmentProductRequestID: Scalars['UUID']['input'];
  decision: Scalars['String']['input'];
  noteReviewer?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  resultProductID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentProductRequestSubmitInput = {
  consignmentProductRequestID: Scalars['UUID']['input'];
};

export type ConsignmentProductRequestSummary = {
  __typename?: 'ConsignmentProductRequestSummary';
  approved: Scalars['Int']['output'];
  cancelled: Scalars['Int']['output'];
  draft: Scalars['Int']['output'];
  inReview: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  submitted: Scalars['Int']['output'];
  totalRequest: Scalars['Int']['output'];
};

export type ConsignmentProductRequestUpdateInput = {
  changeReason?: InputMaybe<Scalars['String']['input']>;
  consignmentProductRequestID: Scalars['UUID']['input'];
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productImageFileID?: InputMaybe<Scalars['UUID']['input']>;
  proposedBarcode?: InputMaybe<Scalars['String']['input']>;
  proposedCategory?: InputMaybe<Scalars['String']['input']>;
  proposedDescription?: InputMaybe<Scalars['String']['input']>;
  proposedPackaging?: InputMaybe<Scalars['String']['input']>;
  proposedProductName: Scalars['String']['input'];
  proposedSellingPrice?: InputMaybe<Scalars['Float']['input']>;
  proposedShelfLife?: InputMaybe<Scalars['String']['input']>;
  proposedWeightGram?: InputMaybe<Scalars['Float']['input']>;
};

export type ConsignmentRegion = {
  __typename?: 'ConsignmentRegion';
  consignmentRegionID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  minStoresPerVendor?: Maybe<Scalars['Int']['output']>;
  regionCode: Scalars['String']['output'];
  regionName: Scalars['String']['output'];
  storeCount: Scalars['Int']['output'];
};

export type ConsignmentRegionCreateInput = {
  regionName: Scalars['String']['input'];
};

export type ConsignmentRegionDeleteInput = {
  consignmentRegionID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type ConsignmentRegionPaged = {
  __typename?: 'ConsignmentRegionPaged';
  items: Array<ConsignmentRegion>;
  pagination: PaginationResult;
};

export type ConsignmentRegionQopFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ConsignmentRegionQopInput = {
  filters?: InputMaybe<ConsignmentRegionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
};

export type ConsignmentRegionUpdateInput = {
  consignmentRegionID: Scalars['UUID']['input'];
  regionName: Scalars['String']['input'];
  version: Scalars['UUID']['input'];
};

export enum ConsignmentRegistrationAccess {
  InviteOnly = 'INVITE_ONLY',
  Open = 'OPEN'
}

export type ConsignmentRegistrationAccessSetting = {
  __typename?: 'ConsignmentRegistrationAccessSetting';
  effectiveValue: ConsignmentRegistrationAccess;
  settingKey: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
  updatedByUserName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<ConsignmentRegistrationAccess>;
  version?: Maybe<Scalars['UUID']['output']>;
};

export type ConsignmentRegistrationAccessUpdateInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  value: ConsignmentRegistrationAccess;
  version: Scalars['UUID']['input'];
};

export enum ConsignmentRegistrationActorType {
  Admin = 'ADMIN',
  System = 'SYSTEM',
  Vendor = 'VENDOR'
}

export type ConsignmentRegistrationAssignInput = {
  assigneeUserID?: InputMaybe<Scalars['UUID']['input']>;
  consignmentRegistrationID: Scalars['UUID']['input'];
  expectedClaimedByUserID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentRegistrationClaimState = {
  __typename?: 'ConsignmentRegistrationClaimState';
  ageDays: Scalars['Int']['output'];
  claimedByMe: Scalars['Boolean']['output'];
  claimedByUserID?: Maybe<Scalars['UUID']['output']>;
  claimedByUserName?: Maybe<Scalars['String']['output']>;
  consignmentRegistrationID: Scalars['UUID']['output'];
  inStageDays: Scalars['Int']['output'];
  isMyTeam: Scalars['Boolean']['output'];
  primaryStatus: ConsignmentRequestPrimaryStatus;
  registrationNumber: Scalars['String']['output'];
  stage: ConsignmentRegistrationStage;
  stageChangedAt: Scalars['Time']['output'];
  teamID: Scalars['UUID']['output'];
  teamName: Scalars['String']['output'];
};

export type ConsignmentRegistrationCuration = {
  __typename?: 'ConsignmentRegistrationCuration';
  barcodeHolderInfoAvailable: Scalars['Boolean']['output'];
  blockers: Array<ConsignmentCurationBlocker>;
  commissionReason?: Maybe<Scalars['String']['output']>;
  consignmentRegistrationID: Scalars['UUID']['output'];
  defaultCommissionPct?: Maybe<Scalars['Int']['output']>;
  endReason?: Maybe<ConsignmentRegistrationEndReason>;
  products: Array<ConsignmentCurationProduct>;
  publishedAt?: Maybe<Scalars['Time']['output']>;
  publishedByUserName?: Maybe<Scalars['String']['output']>;
  publishedMessage?: Maybe<ConsignmentCurationPublishedMessage>;
  reapplyFrom?: Maybe<Scalars['String']['output']>;
  sampleReceivedCount: Scalars['Int']['output'];
  sampleRequiredCount: Scalars['Int']['output'];
  sampleUnconfirmedCount: Scalars['Int']['output'];
  stage: ConsignmentRegistrationStage;
  storeInfoAvailable: Scalars['Boolean']['output'];
  stores: Array<ConsignmentCurationStore>;
  vendorNote?: Maybe<Scalars['String']['output']>;
  version: Scalars['UUID']['output'];
};

export type ConsignmentRegistrationDetail = {
  __typename?: 'ConsignmentRegistrationDetail';
  ageDays: Scalars['Int']['output'];
  claimedByMe: Scalars['Boolean']['output'];
  claimedByUserID?: Maybe<Scalars['UUID']['output']>;
  claimedByUserName?: Maybe<Scalars['String']['output']>;
  consignmentRegistrationID: Scalars['UUID']['output'];
  flags?: Maybe<Array<ConsignmentRegistrationFlag>>;
  inStageDays: Scalars['Int']['output'];
  isMyTeam: Scalars['Boolean']['output'];
  primaryStatus: ConsignmentRequestPrimaryStatus;
  reapplyFrom?: Maybe<Scalars['String']['output']>;
  registrationNumber: Scalars['String']['output'];
  routing?: Maybe<ConsignmentRegistrationRouting>;
  stage: ConsignmentRegistrationStage;
  stageChangedAt: Scalars['Time']['output'];
  stageDeadlineDate?: Maybe<Scalars['String']['output']>;
  stageDeadlinePassed: Scalars['Boolean']['output'];
  submittedAt: Scalars['Time']['output'];
  submittedWhatsApp?: Maybe<ConsignmentRegistrationWhatsAppMessage>;
  teamID: Scalars['UUID']['output'];
  teamName: Scalars['String']['output'];
  transferLog?: Maybe<Array<ConsignmentRegistrationTransfer>>;
  vendor: ConsignmentRegistrationVendor;
  viewMode: ConsignmentRegistrationViewMode;
};

export enum ConsignmentRegistrationEndReason {
  Curation = 'CURATION',
  SampleNotReceived = 'SAMPLE_NOT_RECEIVED',
  StoreUnavailable = 'STORE_UNAVAILABLE'
}

export type ConsignmentRegistrationFlag = {
  __typename?: 'ConsignmentRegistrationFlag';
  kind: ConsignmentRegistrationFlagKind;
  refConsignmentRegistrationID?: Maybe<Scalars['UUID']['output']>;
  refDate?: Maybe<Scalars['String']['output']>;
  refRegistrationNumber?: Maybe<Scalars['String']['output']>;
  refStage?: Maybe<ConsignmentRegistrationStage>;
  refVendorCode?: Maybe<Scalars['String']['output']>;
  refVendorID?: Maybe<Scalars['UUID']['output']>;
  refVendorName?: Maybe<Scalars['String']['output']>;
};

export enum ConsignmentRegistrationFlagKind {
  PreviouslyRejected = 'PREVIOUSLY_REJECTED',
  SimilarBusinessName = 'SIMILAR_BUSINESS_NAME'
}

export type ConsignmentRegistrationHistory = {
  __typename?: 'ConsignmentRegistrationHistory';
  entries: Array<ConsignmentRegistrationHistoryEntry>;
  totalCount: Scalars['Int']['output'];
};

export type ConsignmentRegistrationHistoryEntry = {
  __typename?: 'ConsignmentRegistrationHistoryEntry';
  action: Scalars['String']['output'];
  actorName?: Maybe<Scalars['String']['output']>;
  actorType: ConsignmentRegistrationActorType;
  at: Scalars['Time']['output'];
  consignmentRegistrationHistoryID: Scalars['UUID']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  fromStage?: Maybe<ConsignmentRegistrationStage>;
  reason?: Maybe<Scalars['String']['output']>;
  toStage?: Maybe<ConsignmentRegistrationStage>;
};

export type ConsignmentRegistrationMoveTeamInput = {
  consignmentRegistrationID: Scalars['UUID']['input'];
  expectedTeamID: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
  targetTeamID: Scalars['UUID']['input'];
};

export type ConsignmentRegistrationMoveTeamPreview = {
  __typename?: 'ConsignmentRegistrationMoveTeamPreview';
  currentSampleAddress: Scalars['String']['output'];
  currentTeamID: Scalars['UUID']['output'];
  currentTeamName: Scalars['String']['output'];
  sampleCase: ConsignmentRegistrationMoveTeamSampleCase;
  shippedSampleCount: Scalars['Int']['output'];
  targetSampleAddress: Scalars['String']['output'];
  targetTeamID: Scalars['UUID']['output'];
  targetTeamName: Scalars['String']['output'];
  unshippedSampleCount: Scalars['Int']['output'];
  vendorNotified: Scalars['Boolean']['output'];
};

export type ConsignmentRegistrationMoveTeamPreviewInput = {
  consignmentRegistrationID: Scalars['UUID']['input'];
  targetTeamID: Scalars['UUID']['input'];
};

export enum ConsignmentRegistrationMoveTeamSampleCase {
  AddressChanges = 'ADDRESS_CHANGES',
  NoAddressCheck = 'NO_ADDRESS_CHECK',
  PartlyShipped = 'PARTLY_SHIPPED',
  SameAddress = 'SAME_ADDRESS',
  SampleAtOldAddress = 'SAMPLE_AT_OLD_ADDRESS'
}

export type ConsignmentRegistrationQueueChipCounts = {
  __typename?: 'ConsignmentRegistrationQueueChipCounts';
  activationNotFinished: Scalars['Int']['output'];
  all: Scalars['Int']['output'];
  claimedByMe: Scalars['Int']['output'];
  done: Scalars['Int']['output'];
  unclaimed: Scalars['Int']['output'];
  waitingOnTeam: Scalars['Int']['output'];
  waitingOnVendor: Scalars['Int']['output'];
};

export enum ConsignmentRegistrationQueueClaimFilter {
  All = 'ALL',
  Mine = 'MINE',
  MineOrUnclaimed = 'MINE_OR_UNCLAIMED',
  Unclaimed = 'UNCLAIMED'
}

export type ConsignmentRegistrationQueueItem = {
  __typename?: 'ConsignmentRegistrationQueueItem';
  ageDays: Scalars['Int']['output'];
  claimedByMe: Scalars['Boolean']['output'];
  claimedByUserID?: Maybe<Scalars['UUID']['output']>;
  claimedByUserName?: Maybe<Scalars['String']['output']>;
  consignmentRegistrationID: Scalars['UUID']['output'];
  inStageDays: Scalars['Int']['output'];
  isMyTeam: Scalars['Boolean']['output'];
  primaryStatus: ConsignmentRequestPrimaryStatus;
  registrationNumber: Scalars['String']['output'];
  routing?: Maybe<ConsignmentRegistrationRouting>;
  stage: ConsignmentRegistrationStage;
  stageChangedAt: Scalars['Time']['output'];
  submittedAt: Scalars['Time']['output'];
  teamID: Scalars['UUID']['output'];
  teamName: Scalars['String']['output'];
  vendorName: Scalars['String']['output'];
};

export type ConsignmentRegistrationQueuePaged = {
  __typename?: 'ConsignmentRegistrationQueuePaged';
  items?: Maybe<Array<ConsignmentRegistrationQueueItem>>;
  pagination: PaginationResult;
};

export type ConsignmentRegistrationQueueQopFilterInput = {
  claimedBy?: InputMaybe<ConsignmentRegistrationQueueClaimFilter>;
  primaryStatuses?: InputMaybe<Array<ConsignmentRequestPrimaryStatus>>;
  search?: InputMaybe<Scalars['String']['input']>;
  stages?: InputMaybe<Array<ConsignmentRegistrationStage>>;
  teamID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentRegistrationQueueQopInput = {
  filters?: InputMaybe<ConsignmentRegistrationQueueQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
};

export type ConsignmentRegistrationRouting = {
  __typename?: 'ConsignmentRegistrationRouting';
  nearestDistanceKm?: Maybe<Scalars['Float']['output']>;
  nearestStoreName?: Maybe<Scalars['String']['output']>;
  pinLatitude?: Maybe<Scalars['Float']['output']>;
  pinLongitude?: Maybe<Scalars['Float']['output']>;
  reason: ConsignmentRegistrationRoutingReason;
  routedFromCityCentroid: Scalars['Boolean']['output'];
};

export enum ConsignmentRegistrationRoutingReason {
  NearestStore = 'NEAREST_STORE',
  SingleTeamSelection = 'SINGLE_TEAM_SELECTION',
  TieLowestLoad = 'TIE_LOWEST_LOAD',
  TieRotation = 'TIE_ROTATION'
}

export enum ConsignmentRegistrationSensitiveField {
  PhoneNumber = 'PHONE_NUMBER'
}

export enum ConsignmentRegistrationStage {
  AcceptedFinal = 'ACCEPTED_FINAL',
  Active = 'ACTIVE',
  AwaitingAccountData = 'AWAITING_ACCOUNT_DATA',
  AwaitingActivation = 'AWAITING_ACTIVATION',
  AwaitingContractCheck = 'AWAITING_CONTRACT_CHECK',
  AwaitingSample = 'AWAITING_SAMPLE',
  AwaitingSignature = 'AWAITING_SIGNATURE',
  Claimed = 'CLAIMED',
  Closed = 'CLOSED',
  ContractNeedsFix = 'CONTRACT_NEEDS_FIX',
  InCuration = 'IN_CURATION',
  RejectedFinal = 'REJECTED_FINAL',
  SampleSent = 'SAMPLE_SENT',
  Spam = 'SPAM',
  Submitted = 'SUBMITTED'
}

export type ConsignmentRegistrationTransfer = {
  __typename?: 'ConsignmentRegistrationTransfer';
  at: Scalars['Time']['output'];
  by?: Maybe<Scalars['String']['output']>;
  from: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  sampleAddressChanged?: Maybe<Scalars['Boolean']['output']>;
  to: Scalars['String']['output'];
};

export type ConsignmentRegistrationVendor = {
  __typename?: 'ConsignmentRegistrationVendor';
  addressLine?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  brandOwnership: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  districtName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  heardFrom?: Maybe<Scalars['String']['output']>;
  heardFromDetail?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  phoneNumberMasked?: Maybe<Scalars['String']['output']>;
  productCount: Scalars['Int']['output'];
  provinceName: Scalars['String']['output'];
  targetStoreCount: Scalars['Int']['output'];
  tiktok?: Maybe<Scalars['String']['output']>;
};

export enum ConsignmentRegistrationViewMode {
  Full = 'FULL',
  ReadOnly = 'READ_ONLY'
}

export type ConsignmentRegistrationWhatsAppMessage = {
  __typename?: 'ConsignmentRegistrationWhatsAppMessage';
  lastErrorCode?: Maybe<ConsignmentWhatsAppSendErrorCode>;
  sentAt?: Maybe<Scalars['Time']['output']>;
  status?: Maybe<ConsignmentWhatsAppSendStatus>;
};

export enum ConsignmentRequestPrimaryStatus {
  Closed = 'CLOSED',
  Done = 'DONE',
  WaitingOnTeam = 'WAITING_ON_TEAM',
  WaitingOnVendor = 'WAITING_ON_VENDOR'
}

export type ConsignmentSampleNotReceivedReport = {
  __typename?: 'ConsignmentSampleNotReceivedReport';
  registrationCount: Scalars['Int']['output'];
  rejectedProductCount: Scalars['Int']['output'];
  teams: Array<ConsignmentSampleNotReceivedReportTeam>;
};

export type ConsignmentSampleNotReceivedReportInput = {
  periodEnd: Scalars['Time']['input'];
  periodStart: Scalars['Time']['input'];
  teamIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type ConsignmentSampleNotReceivedReportTeam = {
  __typename?: 'ConsignmentSampleNotReceivedReportTeam';
  registrationCount: Scalars['Int']['output'];
  rejectedProductCount: Scalars['Int']['output'];
  teamID: Scalars['UUID']['output'];
  teamName: Scalars['String']['output'];
};

export type ConsignmentSetupContactChangeInput = {
  value: Scalars['String']['input'];
  version: Scalars['UUID']['input'];
};

export type ConsignmentSetupContactSetting = {
  __typename?: 'ConsignmentSetupContactSetting';
  settingKey: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
  updatedByUserName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['UUID']['output']>;
};

export type ConsignmentSetupContract = {
  __typename?: 'ConsignmentSetupContract';
  completeDataDays: ConsignmentSetupIntSetting;
  defaultAgreementMonths: ConsignmentSetupIntSetting;
  signContractDays: ConsignmentSetupIntSetting;
};

export type ConsignmentSetupContractUpdateInput = {
  completeDataDays?: InputMaybe<ConsignmentSetupIntChangeInput>;
  defaultAgreementMonths?: InputMaybe<ConsignmentSetupIntChangeInput>;
  signContractDays?: InputMaybe<ConsignmentSetupIntChangeInput>;
};

export type ConsignmentSetupContractUpdateResult = {
  __typename?: 'ConsignmentSetupContractUpdateResult';
  changed: Scalars['Boolean']['output'];
  contract: ConsignmentSetupContract;
};

export type ConsignmentSetupIntChangeInput = {
  value: Scalars['Int']['input'];
  version: Scalars['UUID']['input'];
};

export type ConsignmentSetupIntSetting = {
  __typename?: 'ConsignmentSetupIntSetting';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  settingKey: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
  updatedByUserName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['UUID']['output']>;
};

export type ConsignmentSetupRegistration = {
  __typename?: 'ConsignmentSetupRegistration';
  partnerSupportContactWa: ConsignmentSetupContactSetting;
  productsPerRegistration: ConsignmentSetupIntSetting;
  reapplyWaitDays: ConsignmentSetupIntSetting;
  registrationAccess: ConsignmentRegistrationAccessSetting;
  resellerContactWa: ConsignmentSetupContactSetting;
};

export type ConsignmentSetupRegistrationUpdateInput = {
  partnerSupportContactWa?: InputMaybe<ConsignmentSetupContactChangeInput>;
  productsPerRegistration?: InputMaybe<ConsignmentSetupIntChangeInput>;
  reapplyWaitDays?: InputMaybe<ConsignmentSetupIntChangeInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  resellerContactWa?: InputMaybe<ConsignmentSetupContactChangeInput>;
};

export type ConsignmentSetupRegistrationUpdateResult = {
  __typename?: 'ConsignmentSetupRegistrationUpdateResult';
  changed: Scalars['Boolean']['output'];
  registration: ConsignmentSetupRegistration;
};

export type ConsignmentStockIn = {
  __typename?: 'ConsignmentStockIn';
  branch?: Maybe<Branch>;
  branchID: Scalars['UUID']['output'];
  consignmentStockInDatetime: Scalars['Time']['output'];
  consignmentStockInID: Scalars['UUID']['output'];
  consignmentStockInNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  externalReferenceNumber?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<ConsignmentStockInFile>>;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  receivedByName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalItemQtyReceived: Scalars['Float']['output'];
  totalItemWeightReceived: Scalars['Float']['output'];
  vendor: Vendor;
  vendorID: Scalars['UUID']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type ConsignmentStockInCreateInput = {
  branchID: Scalars['UUID']['input'];
  consignmentStockInDatetime: Scalars['Time']['input'];
  consignmentStockInNumber?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNumber: Scalars['String']['input'];
  files?: InputMaybe<Array<ConsignmentStockInFileInput>>;
  items: Array<ConsignmentStockInItemCreateInput>;
  noteInternal: Scalars['String']['input'];
  receivedByName: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type ConsignmentStockInFile = {
  __typename?: 'ConsignmentStockInFile';
  consignmentStockInFileID: Scalars['UUID']['output'];
  consignmentStockInFileType: Scalars['String']['output'];
  consignmentStockInID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ConsignmentStockInFileInput = {
  fileID: Scalars['UUID']['input'];
  fileType: Scalars['String']['input'];
};

export type ConsignmentStockInItem = {
  __typename?: 'ConsignmentStockInItem';
  baseUomQty: Scalars['Float']['output'];
  consignmentStockInID: Scalars['UUID']['output'];
  consignmentStockInItemID: Scalars['UUID']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qtyReceived: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConvertionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type ConsignmentStockInItemCreateInput = {
  productID: Scalars['UUID']['input'];
  qtyReceived: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ConsignmentStockInItemPaged = {
  __typename?: 'ConsignmentStockInItemPaged';
  items: Array<ConsignmentStockInItem>;
  pagination: PaginationResult;
};

export type ConsignmentStockInItemQopFilterInput = {
  consignmentStockInID?: InputMaybe<Scalars['String']['input']>;
  consignmentStockInItemID?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockInItemQopInput = {
  filters?: InputMaybe<ConsignmentStockInItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockInItemUpdateInput = {
  consignmentStockInItemID?: InputMaybe<Scalars['UUID']['input']>;
  productID: Scalars['UUID']['input'];
  qtyReceived: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ConsignmentStockInPaged = {
  __typename?: 'ConsignmentStockInPaged';
  items: Array<ConsignmentStockIn>;
  pagination: PaginationResult;
};

export type ConsignmentStockInQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  consignmentStockInDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  consignmentStockInDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  consignmentStockInNumber?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockInQopInput = {
  filters?: InputMaybe<ConsignmentStockInQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockInRequest = {
  __typename?: 'ConsignmentStockInRequest';
  approvedByUserID?: Maybe<Scalars['UUID']['output']>;
  approvedByUserName?: Maybe<Scalars['String']['output']>;
  approvedDatetime?: Maybe<Scalars['Time']['output']>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  consignmentStockInID?: Maybe<Scalars['UUID']['output']>;
  consignmentStockInNumber: Scalars['String']['output'];
  consignmentStockInRequestID: Scalars['UUID']['output'];
  consignmentStockInRequestNumber: Scalars['String']['output'];
  consignmentStockOutID?: Maybe<Scalars['UUID']['output']>;
  consignmentStockOutNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  estimatedDeliveryDate: Scalars['Time']['output'];
  gmt: Scalars['Int']['output'];
  noteAdditional: Scalars['String']['output'];
  rejectedByUserID?: Maybe<Scalars['UUID']['output']>;
  rejectedByUserName?: Maybe<Scalars['String']['output']>;
  rejectedDatetime?: Maybe<Scalars['Time']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  requestDatetime: Scalars['Time']['output'];
  requestDatetimeUtc: Scalars['Time']['output'];
  status: Scalars['String']['output'];
  submittedByUserID?: Maybe<Scalars['UUID']['output']>;
  submittedByUserName?: Maybe<Scalars['String']['output']>;
  submittedDatetime?: Maybe<Scalars['Time']['output']>;
  totalItemQtyApproved: Scalars['Float']['output'];
  totalItemQtyRequested: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorCode: Scalars['String']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
};

export type ConsignmentStockInRequestApproveInput = {
  consignmentStockInRequestID: Scalars['UUID']['input'];
  files?: InputMaybe<Array<ConsignmentStockInRequestFileInput>>;
  items: Array<ConsignmentStockInRequestApproveItemInput>;
  receivedByName: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type ConsignmentStockInRequestApproveItemInput = {
  consignmentStockInRequestItemID: Scalars['UUID']['input'];
  expiredDate?: InputMaybe<Scalars['Time']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  qtyReceived: Scalars['Float']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type ConsignmentStockInRequestCancelInput = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  consignmentStockInRequestID: Scalars['UUID']['input'];
};

export type ConsignmentStockInRequestCreateInput = {
  branchID: Scalars['UUID']['input'];
  estimatedDeliveryDate: Scalars['Time']['input'];
  files?: InputMaybe<Array<ConsignmentStockInRequestFileInput>>;
  items: Array<ConsignmentStockInRequestItemInput>;
  noteAdditional?: InputMaybe<Scalars['String']['input']>;
  submit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsignmentStockInRequestFile = {
  __typename?: 'ConsignmentStockInRequestFile';
  consignmentStockInRequestFileID: Scalars['UUID']['output'];
  consignmentStockInRequestFileRole: Scalars['String']['output'];
  consignmentStockInRequestID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ConsignmentStockInRequestFileInput = {
  fileID: Scalars['UUID']['input'];
  fileRole: Scalars['String']['input'];
};

export type ConsignmentStockInRequestFilePaged = {
  __typename?: 'ConsignmentStockInRequestFilePaged';
  items: Array<ConsignmentStockInRequestFile>;
  pagination: PaginationResult;
};

export type ConsignmentStockInRequestFileQopFilterInput = {
  consignmentStockInRequestFileRole?: InputMaybe<Scalars['String']['input']>;
  consignmentStockInRequestID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockInRequestFileQopInput = {
  filters?: InputMaybe<ConsignmentStockInRequestFileQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockInRequestItem = {
  __typename?: 'ConsignmentStockInRequestItem';
  baseUomQtyApproved: Scalars['Float']['output'];
  baseUomQtyRequested: Scalars['Float']['output'];
  consignmentStockInRequestID: Scalars['UUID']['output'];
  consignmentStockInRequestItemID: Scalars['UUID']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiredDate?: Maybe<Scalars['Time']['output']>;
  expiredDateConfirmed?: Maybe<Scalars['Time']['output']>;
  noteReason: Scalars['String']['output'];
  noteRequester: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qtyApproved: Scalars['Float']['output'];
  qtyOutstanding: Scalars['Float']['output'];
  qtyReceived: Scalars['Float']['output'];
  qtyRequested: Scalars['Float']['output'];
  receivingReason: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConvertionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type ConsignmentStockInRequestItemInput = {
  expiredDate?: InputMaybe<Scalars['Time']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qtyRequested: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ConsignmentStockInRequestItemPaged = {
  __typename?: 'ConsignmentStockInRequestItemPaged';
  items: Array<ConsignmentStockInRequestItem>;
  pagination: PaginationResult;
};

export type ConsignmentStockInRequestItemQopFilterInput = {
  consignmentStockInRequestID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockInRequestItemQopInput = {
  filters?: InputMaybe<ConsignmentStockInRequestItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockInRequestLabel = {
  __typename?: 'ConsignmentStockInRequestLabel';
  barcode: Scalars['String']['output'];
  copies: Scalars['Int']['output'];
  expiredDate?: Maybe<Scalars['Time']['output']>;
  printable: Scalars['Boolean']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  sellingPrice: Scalars['Float']['output'];
};

export type ConsignmentStockInRequestPaged = {
  __typename?: 'ConsignmentStockInRequestPaged';
  items: Array<ConsignmentStockInRequest>;
  pagination: PaginationResult;
};

export type ConsignmentStockInRequestQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  consignmentStockInRequestNumber?: InputMaybe<Scalars['String']['input']>;
  requestDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  requestDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockInRequestQopInput = {
  filters?: InputMaybe<ConsignmentStockInRequestQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockInRequestRejectInput = {
  consignmentStockInRequestID: Scalars['UUID']['input'];
  rejectionReason: Scalars['String']['input'];
};

export type ConsignmentStockInRequestSubmitInput = {
  consignmentStockInRequestID: Scalars['UUID']['input'];
};

export type ConsignmentStockInRequestSummary = {
  __typename?: 'ConsignmentStockInRequestSummary';
  approved: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  totalRequest: Scalars['Int']['output'];
};

export type ConsignmentStockInRequestUpdateInput = {
  branchID: Scalars['UUID']['input'];
  consignmentStockInRequestID: Scalars['UUID']['input'];
  estimatedDeliveryDate: Scalars['Time']['input'];
  files?: InputMaybe<Array<ConsignmentStockInRequestFileInput>>;
  items: Array<ConsignmentStockInRequestItemInput>;
  noteAdditional?: InputMaybe<Scalars['String']['input']>;
};

export type ConsignmentStockInUpdateInput = {
  branchID: Scalars['UUID']['input'];
  consignmentStockInDatetime: Scalars['Time']['input'];
  consignmentStockInID: Scalars['UUID']['input'];
  consignmentStockInNumber?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNumber: Scalars['String']['input'];
  files?: InputMaybe<Array<ConsignmentStockInFileInput>>;
  items: Array<ConsignmentStockInItemUpdateInput>;
  noteInternal: Scalars['String']['input'];
  receivedByName: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type ConsignmentStockLedgerEntry = {
  __typename?: 'ConsignmentStockLedgerEntry';
  branchID: Scalars['UUID']['output'];
  direction: Scalars['String']['output'];
  entryID: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  qtyBalanceAfter: Scalars['Float']['output'];
  qtyBalanceBefore: Scalars['Float']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  transactionDatetime: Scalars['Time']['output'];
  warehouseID: Scalars['UUID']['output'];
};

export type ConsignmentStockLedgerFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  dateEnd: Scalars['Time']['input'];
  dateStart: Scalars['Time']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  productID: Scalars['UUID']['input'];
};

export type ConsignmentStockLedgerPaged = {
  __typename?: 'ConsignmentStockLedgerPaged';
  items: Array<ConsignmentStockLedgerEntry>;
  totalRows: Scalars['Int']['output'];
};

export type ConsignmentStockMovement = {
  __typename?: 'ConsignmentStockMovement';
  endingQty: Scalars['Float']['output'];
  productID: Scalars['UUID']['output'];
  qtyIn: Scalars['Float']['output'];
  qtyOut: Scalars['Float']['output'];
  startingQty: Scalars['Float']['output'];
};

export type ConsignmentStockMovementFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  dateEnd: Scalars['Time']['input'];
  dateStart: Scalars['Time']['input'];
};

export type ConsignmentStockOut = {
  __typename?: 'ConsignmentStockOut';
  branch?: Maybe<Branch>;
  branchID: Scalars['UUID']['output'];
  consignmentStockOutDatetime: Scalars['Time']['output'];
  consignmentStockOutID: Scalars['UUID']['output'];
  consignmentStockOutNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  externalReferenceNumber?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<ConsignmentStockOutFile>>;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  receivedByVendorName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalItemQty: Scalars['Float']['output'];
  totalItemWeight: Scalars['Float']['output'];
  vendor: Vendor;
  vendorID: Scalars['UUID']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type ConsignmentStockOutCreateInput = {
  branchID: Scalars['UUID']['input'];
  consignmentStockOutDatetime: Scalars['Time']['input'];
  consignmentStockOutNumber?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<ConsignmentStockOutFileInput>>;
  items: Array<ConsignmentStockOutItemCreateInput>;
  noteInternal: Scalars['String']['input'];
  receivedByVendorName: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type ConsignmentStockOutFile = {
  __typename?: 'ConsignmentStockOutFile';
  consignmentStockOutFileID: Scalars['UUID']['output'];
  consignmentStockOutFileType: Scalars['String']['output'];
  consignmentStockOutID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ConsignmentStockOutFileInput = {
  fileID: Scalars['UUID']['input'];
  fileType: Scalars['String']['input'];
};

export type ConsignmentStockOutItem = {
  __typename?: 'ConsignmentStockOutItem';
  baseUomQty: Scalars['Float']['output'];
  consignmentStockOutID: Scalars['UUID']['output'];
  consignmentStockOutItemID: Scalars['UUID']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConvertionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type ConsignmentStockOutItemCreateInput = {
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ConsignmentStockOutItemPaged = {
  __typename?: 'ConsignmentStockOutItemPaged';
  items: Array<ConsignmentStockOutItem>;
  pagination: PaginationResult;
};

export type ConsignmentStockOutItemQopFilterInput = {
  consignmentStockOutID?: InputMaybe<Scalars['String']['input']>;
  consignmentStockOutItemID?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockOutItemQopInput = {
  filters?: InputMaybe<ConsignmentStockOutItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockOutItemUpdateInput = {
  consignmentStockOutItemID?: InputMaybe<Scalars['UUID']['input']>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ConsignmentStockOutPaged = {
  __typename?: 'ConsignmentStockOutPaged';
  items: Array<ConsignmentStockOut>;
  pagination: PaginationResult;
};

export type ConsignmentStockOutQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  consignmentStockOutDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  consignmentStockOutDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  consignmentStockOutNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockOutQopInput = {
  filters?: InputMaybe<ConsignmentStockOutQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockOutUpdateInput = {
  branchID: Scalars['UUID']['input'];
  consignmentStockOutDatetime: Scalars['Time']['input'];
  consignmentStockOutID: Scalars['UUID']['input'];
  consignmentStockOutNumber?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<ConsignmentStockOutFileInput>>;
  items: Array<ConsignmentStockOutItemUpdateInput>;
  noteInternal: Scalars['String']['input'];
  receivedByVendorName: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type ConsignmentStoreCoordinateInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export enum ConsignmentStoreCoordinateStatus {
  Missing = 'MISSING',
  OutsideIndonesia = 'OUTSIDE_INDONESIA',
  Valid = 'VALID'
}

export enum ConsignmentStoreNotReadyReason {
  BranchInactive = 'BRANCH_INACTIVE',
  BranchNotFound = 'BRANCH_NOT_FOUND',
  CannotTakeConsignment = 'CANNOT_TAKE_CONSIGNMENT',
  CoordinatesOutsideIndonesia = 'COORDINATES_OUTSIDE_INDONESIA',
  NoCoordinates = 'NO_COORDINATES',
  NoRegion = 'NO_REGION',
  NoTeam = 'NO_TEAM',
  RegionInactive = 'REGION_INACTIVE',
  TeamInactive = 'TEAM_INACTIVE',
  TeamWithoutActiveMember = 'TEAM_WITHOUT_ACTIVE_MEMBER'
}

export enum ConsignmentStoreReadiness {
  NotReady = 'NOT_READY',
  Ready = 'READY'
}

export type ConsignmentStoreRegionRef = {
  __typename?: 'ConsignmentStoreRegionRef';
  consignmentRegionID: Scalars['UUID']['output'];
  regionName: Scalars['String']['output'];
};

export type ConsignmentStoreSetting = {
  __typename?: 'ConsignmentStoreSetting';
  branchActive: Scalars['Boolean']['output'];
  branchCategoryName: Scalars['String']['output'];
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  canTakeConsignment: Scalars['Boolean']['output'];
  cityName: Scalars['String']['output'];
  coordinateStatus: ConsignmentStoreCoordinateStatus;
  entityAuditMetadata?: Maybe<EntityAuditMetadata>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  notReadyReason?: Maybe<ConsignmentStoreNotReadyReason>;
  notReadyTeamName?: Maybe<Scalars['String']['output']>;
  openToNewVendors: Scalars['Boolean']['output'];
  readiness: ConsignmentStoreReadiness;
  region?: Maybe<ConsignmentStoreRegionRef>;
  team?: Maybe<ConsignmentStoreTeamRef>;
  version?: Maybe<Scalars['UUID']['output']>;
};

export type ConsignmentStoreSettingPaged = {
  __typename?: 'ConsignmentStoreSettingPaged';
  items: Array<ConsignmentStoreSetting>;
  pagination: PaginationResult;
};

export type ConsignmentStoreSettingQopFilterInput = {
  branchActive?: InputMaybe<Scalars['Boolean']['input']>;
  consignmentRegionID?: InputMaybe<Scalars['UUID']['input']>;
  consignmentTeamID?: InputMaybe<Scalars['UUID']['input']>;
  readiness?: InputMaybe<ConsignmentStoreReadiness>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ConsignmentStoreSettingQopInput = {
  filters?: InputMaybe<ConsignmentStoreSettingQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
};

export type ConsignmentStoreSettingUpdateInput = {
  branchID: Scalars['UUID']['input'];
  canTakeConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  consignmentRegionID?: InputMaybe<Scalars['UUID']['input']>;
  coordinate?: InputMaybe<ConsignmentStoreCoordinateInput>;
  openToNewVendors?: InputMaybe<Scalars['Boolean']['input']>;
  team?: InputMaybe<ConsignmentStoreTeamChangeInput>;
  version?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStoreSettingUpdateResult = {
  __typename?: 'ConsignmentStoreSettingUpdateResult';
  changed: Scalars['Boolean']['output'];
  store: ConsignmentStoreSetting;
};

export type ConsignmentStoreTeamChangeInput = {
  consignmentTeamID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStoreTeamRef = {
  __typename?: 'ConsignmentStoreTeamRef';
  consignmentTeamID: Scalars['UUID']['output'];
  teamName: Scalars['String']['output'];
};

export type ConsignmentTeam = {
  __typename?: 'ConsignmentTeam';
  activeMemberCount: Scalars['Int']['output'];
  consignmentTeamID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  members: Array<ConsignmentTeamMember>;
  openRegistrationCount: Scalars['Int']['output'];
  sampleAddress: Scalars['String']['output'];
  status: ConsignmentTeamStatus;
  storeCount: Scalars['Int']['output'];
  teamName: Scalars['String']['output'];
  used: Scalars['Boolean']['output'];
  vendorCount: Scalars['Int']['output'];
  whatsappContact: Scalars['String']['output'];
};

export type ConsignmentTeamCreateInput = {
  memberUserIDs: Array<Scalars['UUID']['input']>;
  sampleAddress: Scalars['String']['input'];
  teamName: Scalars['String']['input'];
  whatsappContact: Scalars['String']['input'];
};

export type ConsignmentTeamMember = {
  __typename?: 'ConsignmentTeamMember';
  consignmentTeamMemberID: Scalars['UUID']['output'];
  userActive: Scalars['Boolean']['output'];
  userID: Scalars['UUID']['output'];
  userName: Scalars['String']['output'];
};

export type ConsignmentTeamPaged = {
  __typename?: 'ConsignmentTeamPaged';
  items: Array<ConsignmentTeam>;
  pagination: PaginationResult;
};

export type ConsignmentTeamQopFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConsignmentTeamStatus>;
};

export type ConsignmentTeamQopInput = {
  filters?: InputMaybe<ConsignmentTeamQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
};

export enum ConsignmentTeamStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ConsignmentTeamUpdateInput = {
  consignmentTeamID: Scalars['UUID']['input'];
  memberUserIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sampleAddress?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['UUID']['input'];
  whatsappContact?: InputMaybe<Scalars['String']['input']>;
};

export type ConsignmentVendorProduct = {
  __typename?: 'ConsignmentVendorProduct';
  barcode: Scalars['String']['output'];
  baseUomID: Scalars['UUID']['output'];
  imageSmallURL: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyOnHand: Scalars['Float']['output'];
  sellingPrice: Scalars['Float']['output'];
};

export type ConsignmentVendorProductPerformance = {
  __typename?: 'ConsignmentVendorProductPerformance';
  commissionAmount: Scalars['Float']['output'];
  endingQty: Scalars['Float']['output'];
  grossSales: Scalars['Float']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyIn: Scalars['Float']['output'];
  qtyOut: Scalars['Float']['output'];
  qtySold: Scalars['Float']['output'];
  startingQty: Scalars['Float']['output'];
  uomName: Scalars['String']['output'];
  vendorIncome: Scalars['Float']['output'];
};

export type ConsignmentVendorProductPerformancePaged = {
  __typename?: 'ConsignmentVendorProductPerformancePaged';
  items: Array<ConsignmentVendorProductPerformance>;
  pagination: PaginationResult;
  totals: ConsignmentVendorProductPerformanceTotals;
};

export type ConsignmentVendorProductPerformanceQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  dateEnd: Scalars['Time']['input'];
  dateStart: Scalars['Time']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ConsignmentVendorProductPerformanceQopInput = {
  filters: ConsignmentVendorProductPerformanceQopFilterInput;
  pagination?: InputMaybe<Pagination>;
};

export type ConsignmentVendorProductPerformanceTotals = {
  __typename?: 'ConsignmentVendorProductPerformanceTotals';
  commissionAmount: Scalars['Float']['output'];
  endingQty: Scalars['Float']['output'];
  grossSales: Scalars['Float']['output'];
  qtyIn: Scalars['Float']['output'];
  qtyOut: Scalars['Float']['output'];
  qtySold: Scalars['Float']['output'];
  startingQty: Scalars['Float']['output'];
  vendorIncome: Scalars['Float']['output'];
};

export type ConsignmentVendorProfile = {
  __typename?: 'ConsignmentVendorProfile';
  photoFileID?: Maybe<Scalars['UUID']['output']>;
  photoImageLargeURL: Scalars['String']['output'];
  photoImageMediumURL: Scalars['String']['output'];
  photoImageSmallURL: Scalars['String']['output'];
  vendorID: Scalars['UUID']['output'];
};

export type ConsignmentVendorProfileDetail = {
  __typename?: 'ConsignmentVendorProfileDetail';
  bankAccountName: Scalars['String']['output'];
  bankAccountNumber: Scalars['String']['output'];
  bankID: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  cityID: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  fullAddress: Scalars['String']['output'];
  hasCompleteBank: Scalars['Boolean']['output'];
  npwp: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  provinceID: Scalars['String']['output'];
  provinceName: Scalars['String']['output'];
  subdistrictID: Scalars['String']['output'];
  subdistrictName: Scalars['String']['output'];
  vendorCode: Scalars['String']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
};

export type ConsignmentVendorProfileUpdateInput = {
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankID?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  cityID?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  npwp?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
  provinceName?: InputMaybe<Scalars['String']['input']>;
  subdistrictID?: InputMaybe<Scalars['String']['input']>;
  subdistrictName?: InputMaybe<Scalars['String']['input']>;
};

export type ConsignmentVendorRegistration = {
  __typename?: 'ConsignmentVendorRegistration';
  approvedByUserName?: Maybe<Scalars['String']['output']>;
  approvedDatetime?: Maybe<Scalars['Time']['output']>;
  businessAddress: Scalars['String']['output'];
  businessCity: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  businessPermits: Array<Scalars['String']['output']>;
  businessType: Scalars['String']['output'];
  consignmentVendorRegistrationID: Scalars['UUID']['output'];
  contactEmail: Scalars['String']['output'];
  contactIDCardFileID?: Maybe<Scalars['UUID']['output']>;
  contactIDCardImageLargeURL: Scalars['String']['output'];
  contactIDCardImageMediumURL: Scalars['String']['output'];
  contactIDCardImageSmallURL: Scalars['String']['output'];
  contactIDCardNumber: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhoneNumber: Scalars['String']['output'];
  contactPosition: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  inReviewByUserName?: Maybe<Scalars['String']['output']>;
  inReviewDatetime?: Maybe<Scalars['Time']['output']>;
  items: Array<ConsignmentVendorRegistrationItem>;
  noteApplicant: Scalars['String']['output'];
  noteReviewer: Scalars['String']['output'];
  npwp: Scalars['String']['output'];
  registrationCode: Scalars['String']['output'];
  registrationDatetime: Scalars['Time']['output'];
  rejectedByUserName?: Maybe<Scalars['String']['output']>;
  rejectedDatetime?: Maybe<Scalars['Time']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  selectedBranchIDs: Array<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalItemAccepted: Scalars['Int']['output'];
  totalItemRegistered: Scalars['Int']['output'];
  vendorCode: Scalars['String']['output'];
  vendorID?: Maybe<Scalars['UUID']['output']>;
};

export type ConsignmentVendorRegistrationItem = {
  __typename?: 'ConsignmentVendorRegistrationItem';
  barcode: Scalars['String']['output'];
  consignmentVendorRegistrationID: Scalars['UUID']['output'];
  consignmentVendorRegistrationItemID: Scalars['UUID']['output'];
  description: Scalars['String']['output'];
  lineNumber: Scalars['Int']['output'];
  noteApplicant: Scalars['String']['output'];
  noteReviewer: Scalars['String']['output'];
  packaging: Scalars['String']['output'];
  productCategory: Scalars['String']['output'];
  productImageFileID?: Maybe<Scalars['UUID']['output']>;
  productImageLargeURL: Scalars['String']['output'];
  productImageMediumURL: Scalars['String']['output'];
  productImageSmallURL: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  productionCapacity: Scalars['String']['output'];
  proposedPrice: Scalars['Float']['output'];
  reviewedDatetime?: Maybe<Scalars['Time']['output']>;
  shelfLife: Scalars['String']['output'];
  status: Scalars['String']['output'];
  weightGram: Scalars['Float']['output'];
};

export type ConsignmentVendorRegistrationPaged = {
  __typename?: 'ConsignmentVendorRegistrationPaged';
  items: Array<ConsignmentVendorRegistration>;
  pagination: PaginationResult;
};

export type ConsignmentVendorRegistrationQopFilterInput = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  registrationCode?: InputMaybe<Scalars['String']['input']>;
  registrationDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  registrationDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ConsignmentVendorRegistrationQopInput = {
  filters?: InputMaybe<ConsignmentVendorRegistrationQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentVendorRegistrationReviewInput = {
  consignmentVendorRegistrationID: Scalars['UUID']['input'];
  decision: Scalars['String']['input'];
  items?: InputMaybe<Array<ConsignmentVendorRegistrationReviewItemInput>>;
  noteReviewer?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  vendorCode?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentVendorRegistrationReviewItemInput = {
  consignmentVendorRegistrationItemID: Scalars['UUID']['input'];
  noteReviewer?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
};

export type ConsignmentVendorRegistrationSummary = {
  __typename?: 'ConsignmentVendorRegistrationSummary';
  approved: Scalars['Int']['output'];
  inReview: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  submitted: Scalars['Int']['output'];
  totalRegistration: Scalars['Int']['output'];
};

export enum ConsignmentWhatsAppSendErrorCode {
  GatewayRejected = 'GATEWAY_REJECTED',
  GatewayUnreachable = 'GATEWAY_UNREACHABLE',
  MessageNotRendered = 'MESSAGE_NOT_RENDERED',
  Unknown = 'UNKNOWN'
}

export enum ConsignmentWhatsAppSendStatus {
  NotDelivered = 'NOT_DELIVERED',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export type EntityAuditMetadata = {
  __typename?: 'EntityAuditMetadata';
  createdAt: Scalars['Time']['output'];
  createdByUserID?: Maybe<Scalars['UUID']['output']>;
  createdByUserName?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  deletedByUserID?: Maybe<Scalars['UUID']['output']>;
  deletedByUserName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  updatedByUserID?: Maybe<Scalars['UUID']['output']>;
  updatedByUserName?: Maybe<Scalars['String']['output']>;
  version: Scalars['UUID']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  consignmentCurationUpdate: ConsignmentCurationUpdateResult;
  consignmentPilotInviteCreate: ConsignmentPilotInvite;
  consignmentPilotInviteDelete: Scalars['Boolean']['output'];
  consignmentPilotInviteImport: ConsignmentPilotInviteImportResult;
  consignmentProductRequestCancel: Scalars['Boolean']['output'];
  consignmentProductRequestCreate: ConsignmentProductRequest;
  consignmentProductRequestPrepareMasterdataFile: Scalars['String']['output'];
  consignmentProductRequestReview: ConsignmentProductRequest;
  consignmentProductRequestSubmit: ConsignmentProductRequest;
  consignmentProductRequestUpdate: ConsignmentProductRequest;
  consignmentRegionCreate: ConsignmentRegion;
  consignmentRegionDelete: Scalars['Boolean']['output'];
  consignmentRegionUpdate: ConsignmentRegion;
  consignmentRegistrationAccessUpdate: ConsignmentSetupRegistrationUpdateResult;
  consignmentRegistrationAssign: ConsignmentRegistrationClaimState;
  consignmentRegistrationAssignAllTeams: ConsignmentRegistrationClaimState;
  consignmentRegistrationClaim: ConsignmentRegistrationClaimState;
  consignmentRegistrationCurationBarcodeCheck: ConsignmentRegistrationCuration;
  consignmentRegistrationCurationLabelName: ConsignmentRegistrationCuration;
  consignmentRegistrationCurationProductDecide: ConsignmentRegistrationCuration;
  consignmentRegistrationCurationPublish: ConsignmentRegistrationCuration;
  consignmentRegistrationMoveTeam: ConsignmentRegistrationClaimState;
  consignmentRegistrationProductSwitchToPhotoOnly: ConsignmentRegistrationCuration;
  consignmentRegistrationRelease: ConsignmentRegistrationClaimState;
  consignmentRegistrationSampleReceive: ConsignmentRegistrationCuration;
  consignmentRegistrationShowField: Scalars['String']['output'];
  consignmentRegistrationShowFieldAllTeams: Scalars['String']['output'];
  consignmentSetupContractUpdate: ConsignmentSetupContractUpdateResult;
  consignmentSetupRegistrationUpdate: ConsignmentSetupRegistrationUpdateResult;
  consignmentStockInCancel: Scalars['Boolean']['output'];
  consignmentStockInConfirm: ConsignmentStockIn;
  consignmentStockInCreate: ConsignmentStockIn;
  consignmentStockInRequestApprove: ConsignmentStockInRequest;
  consignmentStockInRequestCancel: Scalars['Boolean']['output'];
  consignmentStockInRequestCreate: ConsignmentStockInRequest;
  consignmentStockInRequestReject: ConsignmentStockInRequest;
  consignmentStockInRequestSubmit: ConsignmentStockInRequest;
  consignmentStockInRequestUpdate: ConsignmentStockInRequest;
  consignmentStockInUpdate: ConsignmentStockIn;
  consignmentStockOutCancel: Scalars['Boolean']['output'];
  consignmentStockOutConfirm: ConsignmentStockOut;
  consignmentStockOutCreate: ConsignmentStockOut;
  consignmentStockOutUpdate: ConsignmentStockOut;
  consignmentStoreSettingUpdate: ConsignmentStoreSettingUpdateResult;
  consignmentTeamCreate: ConsignmentTeam;
  consignmentTeamDelete: Scalars['Boolean']['output'];
  consignmentTeamUpdate: ConsignmentTeam;
  consignmentVendorProfileUpdate: ConsignmentVendorProfileDetail;
  consignmentVendorRegistrationReview: ConsignmentVendorRegistration;
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationConsignmentCurationUpdateArgs = {
  input: ConsignmentCurationUpdateInput;
};


export type MutationConsignmentPilotInviteCreateArgs = {
  input: ConsignmentPilotInviteCreateInput;
};


export type MutationConsignmentPilotInviteDeleteArgs = {
  consignmentPilotInviteID: Scalars['UUID']['input'];
};


export type MutationConsignmentPilotInviteImportArgs = {
  input: ConsignmentPilotInviteImportInput;
};


export type MutationConsignmentProductRequestCancelArgs = {
  input: ConsignmentProductRequestCancelInput;
};


export type MutationConsignmentProductRequestCreateArgs = {
  input: ConsignmentProductRequestCreateInput;
};


export type MutationConsignmentProductRequestPrepareMasterdataFileArgs = {
  consignmentProductRequestID: Scalars['UUID']['input'];
};


export type MutationConsignmentProductRequestReviewArgs = {
  input: ConsignmentProductRequestReviewInput;
};


export type MutationConsignmentProductRequestSubmitArgs = {
  input: ConsignmentProductRequestSubmitInput;
};


export type MutationConsignmentProductRequestUpdateArgs = {
  input: ConsignmentProductRequestUpdateInput;
};


export type MutationConsignmentRegionCreateArgs = {
  input: ConsignmentRegionCreateInput;
};


export type MutationConsignmentRegionDeleteArgs = {
  input: ConsignmentRegionDeleteInput;
};


export type MutationConsignmentRegionUpdateArgs = {
  input: ConsignmentRegionUpdateInput;
};


export type MutationConsignmentRegistrationAccessUpdateArgs = {
  input: ConsignmentRegistrationAccessUpdateInput;
};


export type MutationConsignmentRegistrationAssignArgs = {
  input: ConsignmentRegistrationAssignInput;
};


export type MutationConsignmentRegistrationAssignAllTeamsArgs = {
  input: ConsignmentRegistrationAssignInput;
};


export type MutationConsignmentRegistrationClaimArgs = {
  consignmentRegistrationID: Scalars['UUID']['input'];
};


export type MutationConsignmentRegistrationCurationBarcodeCheckArgs = {
  consignmentRegistrationID: Scalars['UUID']['input'];
};


export type MutationConsignmentRegistrationCurationLabelNameArgs = {
  input: ConsignmentCurationLabelNameInput;
};


export type MutationConsignmentRegistrationCurationProductDecideArgs = {
  input: ConsignmentCurationProductDecideInput;
};


export type MutationConsignmentRegistrationCurationPublishArgs = {
  input: ConsignmentCurationPublishInput;
};


export type MutationConsignmentRegistrationMoveTeamArgs = {
  input: ConsignmentRegistrationMoveTeamInput;
};


export type MutationConsignmentRegistrationProductSwitchToPhotoOnlyArgs = {
  input: ConsignmentCurationProductSwitchToPhotoOnlyInput;
};


export type MutationConsignmentRegistrationReleaseArgs = {
  consignmentRegistrationID: Scalars['UUID']['input'];
};


export type MutationConsignmentRegistrationSampleReceiveArgs = {
  input: ConsignmentCurationSampleReceiveInput;
};


export type MutationConsignmentRegistrationShowFieldArgs = {
  consignmentRegistrationID: Scalars['UUID']['input'];
  field: ConsignmentRegistrationSensitiveField;
};


export type MutationConsignmentRegistrationShowFieldAllTeamsArgs = {
  consignmentRegistrationID: Scalars['UUID']['input'];
  field: ConsignmentRegistrationSensitiveField;
};


export type MutationConsignmentSetupContractUpdateArgs = {
  input: ConsignmentSetupContractUpdateInput;
};


export type MutationConsignmentSetupRegistrationUpdateArgs = {
  input: ConsignmentSetupRegistrationUpdateInput;
};


export type MutationConsignmentStockInCancelArgs = {
  consignmentStockInID: Scalars['UUID']['input'];
};


export type MutationConsignmentStockInConfirmArgs = {
  consignmentStockInID: Scalars['UUID']['input'];
};


export type MutationConsignmentStockInCreateArgs = {
  input: ConsignmentStockInCreateInput;
};


export type MutationConsignmentStockInRequestApproveArgs = {
  input: ConsignmentStockInRequestApproveInput;
};


export type MutationConsignmentStockInRequestCancelArgs = {
  input: ConsignmentStockInRequestCancelInput;
};


export type MutationConsignmentStockInRequestCreateArgs = {
  input: ConsignmentStockInRequestCreateInput;
};


export type MutationConsignmentStockInRequestRejectArgs = {
  input: ConsignmentStockInRequestRejectInput;
};


export type MutationConsignmentStockInRequestSubmitArgs = {
  input: ConsignmentStockInRequestSubmitInput;
};


export type MutationConsignmentStockInRequestUpdateArgs = {
  input: ConsignmentStockInRequestUpdateInput;
};


export type MutationConsignmentStockInUpdateArgs = {
  input: ConsignmentStockInUpdateInput;
};


export type MutationConsignmentStockOutCancelArgs = {
  consignmentStockOutID: Scalars['UUID']['input'];
};


export type MutationConsignmentStockOutConfirmArgs = {
  consignmentStockOutID: Scalars['UUID']['input'];
};


export type MutationConsignmentStockOutCreateArgs = {
  input: ConsignmentStockOutCreateInput;
};


export type MutationConsignmentStockOutUpdateArgs = {
  input: ConsignmentStockOutUpdateInput;
};


export type MutationConsignmentStoreSettingUpdateArgs = {
  input: ConsignmentStoreSettingUpdateInput;
};


export type MutationConsignmentTeamCreateArgs = {
  input: ConsignmentTeamCreateInput;
};


export type MutationConsignmentTeamDeleteArgs = {
  consignmentTeamID: Scalars['UUID']['input'];
};


export type MutationConsignmentTeamUpdateArgs = {
  input: ConsignmentTeamUpdateInput;
};


export type MutationConsignmentVendorProfileUpdateArgs = {
  input: ConsignmentVendorProfileUpdateInput;
};


export type MutationConsignmentVendorRegistrationReviewArgs = {
  input: ConsignmentVendorRegistrationReviewInput;
};

export type Pagination = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  withCount?: InputMaybe<Scalars['Boolean']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaginationResult = {
  __typename?: 'PaginationResult';
  hasNext?: Maybe<Scalars['Boolean']['output']>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalRows?: Maybe<Scalars['Int']['output']>;
};

export type Product = {
  __typename?: 'Product';
  productID: Scalars['UUID']['output'];
};

export type Query = {
  __typename?: 'Query';
  consignmentChangeHistory: ConsignmentChangeHistoryPaged;
  consignmentChangeHistoryActors: ConsignmentChangeHistoryActorPaged;
  consignmentCuration: ConsignmentCuration;
  consignmentPilotInviteImportPreview: ConsignmentPilotInviteImportPreview;
  consignmentPilotInvites: ConsignmentPilotInvitePaged;
  consignmentProductRequest?: Maybe<ConsignmentProductRequest>;
  consignmentProductRequestSummary: ConsignmentProductRequestSummary;
  consignmentProductRequests: ConsignmentProductRequestPaged;
  consignmentRegions: ConsignmentRegionPaged;
  consignmentRegistrationCuration: ConsignmentRegistrationCuration;
  consignmentRegistrationCurationAllTeams: ConsignmentRegistrationCuration;
  consignmentRegistrationCurationPublishPreview: ConsignmentCurationPublishPreview;
  consignmentRegistrationDetail: ConsignmentRegistrationDetail;
  consignmentRegistrationDetailAllTeams: ConsignmentRegistrationDetail;
  consignmentRegistrationHistory: ConsignmentRegistrationHistory;
  consignmentRegistrationHistoryAllTeams: ConsignmentRegistrationHistory;
  consignmentRegistrationMoveTeamPreview: ConsignmentRegistrationMoveTeamPreview;
  consignmentRegistrationQueue: ConsignmentRegistrationQueuePaged;
  consignmentRegistrationQueueAllTeams: ConsignmentRegistrationQueuePaged;
  consignmentRegistrationQueueChipCounts: ConsignmentRegistrationQueueChipCounts;
  consignmentRegistrationQueueChipCountsAllTeams: ConsignmentRegistrationQueueChipCounts;
  consignmentSampleNotReceivedReport: ConsignmentSampleNotReceivedReport;
  consignmentSetupContract: ConsignmentSetupContract;
  consignmentSetupRegistration: ConsignmentSetupRegistration;
  consignmentStockIn?: Maybe<ConsignmentStockIn>;
  consignmentStockInItem?: Maybe<ConsignmentStockInItem>;
  consignmentStockInItems: ConsignmentStockInItemPaged;
  consignmentStockInRequest?: Maybe<ConsignmentStockInRequest>;
  consignmentStockInRequestFiles: ConsignmentStockInRequestFilePaged;
  consignmentStockInRequestItems: ConsignmentStockInRequestItemPaged;
  consignmentStockInRequestLabels: Array<ConsignmentStockInRequestLabel>;
  consignmentStockInRequestSummary: ConsignmentStockInRequestSummary;
  consignmentStockInRequests: ConsignmentStockInRequestPaged;
  consignmentStockIns: ConsignmentStockInPaged;
  consignmentStockLedgerByProduct: ConsignmentStockLedgerPaged;
  consignmentStockMovementByProduct: Array<ConsignmentStockMovement>;
  consignmentStockOut?: Maybe<ConsignmentStockOut>;
  consignmentStockOutItem?: Maybe<ConsignmentStockOutItem>;
  consignmentStockOutItems: ConsignmentStockOutItemPaged;
  consignmentStockOuts: ConsignmentStockOutPaged;
  consignmentStoreSettings: ConsignmentStoreSettingPaged;
  consignmentTeams: ConsignmentTeamPaged;
  consignmentVendorProductPerformances: ConsignmentVendorProductPerformancePaged;
  consignmentVendorProducts: Array<ConsignmentVendorProduct>;
  consignmentVendorProfile: ConsignmentVendorProfile;
  consignmentVendorProfileDetail: ConsignmentVendorProfileDetail;
  consignmentVendorRegistration?: Maybe<ConsignmentVendorRegistration>;
  consignmentVendorRegistrationSummary: ConsignmentVendorRegistrationSummary;
  consignmentVendorRegistrations: ConsignmentVendorRegistrationPaged;
  health?: Maybe<Scalars['Boolean']['output']>;
  vendorSalesDashboard: VendorSalesDashboard;
  vendorSalesExport: VendorSalesExportResult;
  vendorSalesInvoice?: Maybe<VendorSalesInvoiceDetail>;
  vendorSalesInvoiceItems: VendorSalesInvoiceItemPaged;
  vendorSalesInvoices: VendorSalesInvoicePaged;
  vendorStockByBranch: VendorStockBranchPaged;
};


export type QueryConsignmentChangeHistoryArgs = {
  qop?: InputMaybe<ConsignmentChangeHistoryQopInput>;
};


export type QueryConsignmentChangeHistoryActorsArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  qop?: InputMaybe<ConsignmentChangeHistoryActorQopInput>;
};


export type QueryConsignmentPilotInviteImportPreviewArgs = {
  input: ConsignmentPilotInviteImportInput;
};


export type QueryConsignmentPilotInvitesArgs = {
  qop?: InputMaybe<ConsignmentPilotInviteQopInput>;
};


export type QueryConsignmentProductRequestArgs = {
  consignmentProductRequestID: Scalars['UUID']['input'];
};


export type QueryConsignmentProductRequestSummaryArgs = {
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryConsignmentProductRequestsArgs = {
  qop?: InputMaybe<ConsignmentProductRequestQopInput>;
};


export type QueryConsignmentRegionsArgs = {
  qop?: InputMaybe<ConsignmentRegionQopInput>;
};


export type QueryConsignmentRegistrationCurationArgs = {
  consignmentRegistrationID: Scalars['UUID']['input'];
};


export type QueryConsignmentRegistrationCurationAllTeamsArgs = {
  consignmentRegistrationID: Scalars['UUID']['input'];
};


export type QueryConsignmentRegistrationCurationPublishPreviewArgs = {
  consignmentRegistrationID: Scalars['UUID']['input'];
  vendorNote?: InputMaybe<Scalars['String']['input']>;
};


export type QueryConsignmentRegistrationDetailArgs = {
  consignmentRegistrationID: Scalars['UUID']['input'];
};


export type QueryConsignmentRegistrationDetailAllTeamsArgs = {
  consignmentRegistrationID: Scalars['UUID']['input'];
};


export type QueryConsignmentRegistrationHistoryArgs = {
  consignmentRegistrationID: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConsignmentRegistrationHistoryAllTeamsArgs = {
  consignmentRegistrationID: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConsignmentRegistrationMoveTeamPreviewArgs = {
  input: ConsignmentRegistrationMoveTeamPreviewInput;
};


export type QueryConsignmentRegistrationQueueArgs = {
  qop?: InputMaybe<ConsignmentRegistrationQueueQopInput>;
};


export type QueryConsignmentRegistrationQueueAllTeamsArgs = {
  qop?: InputMaybe<ConsignmentRegistrationQueueQopInput>;
};


export type QueryConsignmentRegistrationQueueChipCountsArgs = {
  teamID?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryConsignmentRegistrationQueueChipCountsAllTeamsArgs = {
  teamID?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryConsignmentSampleNotReceivedReportArgs = {
  input: ConsignmentSampleNotReceivedReportInput;
};


export type QueryConsignmentStockInArgs = {
  consignmentStockInID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockInItemArgs = {
  consignmentStockInItemID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockInItemsArgs = {
  qop?: InputMaybe<ConsignmentStockInItemQopInput>;
};


export type QueryConsignmentStockInRequestArgs = {
  consignmentStockInRequestID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockInRequestFilesArgs = {
  qop?: InputMaybe<ConsignmentStockInRequestFileQopInput>;
};


export type QueryConsignmentStockInRequestItemsArgs = {
  qop?: InputMaybe<ConsignmentStockInRequestItemQopInput>;
};


export type QueryConsignmentStockInRequestLabelsArgs = {
  consignmentStockInRequestID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockInRequestSummaryArgs = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryConsignmentStockInRequestsArgs = {
  qop?: InputMaybe<ConsignmentStockInRequestQopInput>;
};


export type QueryConsignmentStockInsArgs = {
  qop?: InputMaybe<ConsignmentStockInQopInput>;
};


export type QueryConsignmentStockLedgerByProductArgs = {
  filter: ConsignmentStockLedgerFilterInput;
};


export type QueryConsignmentStockMovementByProductArgs = {
  filter: ConsignmentStockMovementFilterInput;
};


export type QueryConsignmentStockOutArgs = {
  consignmentStockOutID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockOutItemArgs = {
  consignmentStockOutItemID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockOutItemsArgs = {
  qop?: InputMaybe<ConsignmentStockOutItemQopInput>;
};


export type QueryConsignmentStockOutsArgs = {
  qop?: InputMaybe<ConsignmentStockOutQopInput>;
};


export type QueryConsignmentStoreSettingsArgs = {
  qop?: InputMaybe<ConsignmentStoreSettingQopInput>;
};


export type QueryConsignmentTeamsArgs = {
  qop?: InputMaybe<ConsignmentTeamQopInput>;
};


export type QueryConsignmentVendorProductPerformancesArgs = {
  qop: ConsignmentVendorProductPerformanceQopInput;
};


export type QueryConsignmentVendorProductsArgs = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryConsignmentVendorRegistrationArgs = {
  consignmentVendorRegistrationID: Scalars['UUID']['input'];
};


export type QueryConsignmentVendorRegistrationsArgs = {
  qop?: InputMaybe<ConsignmentVendorRegistrationQopInput>;
};


export type QueryVendorSalesDashboardArgs = {
  filter: VendorSalesDashboardFilterInput;
};


export type QueryVendorSalesExportArgs = {
  filter: VendorSalesExportFilterInput;
};


export type QueryVendorSalesInvoiceArgs = {
  salesConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type QueryVendorSalesInvoiceItemsArgs = {
  qop?: InputMaybe<VendorSalesInvoiceItemQopInput>;
};


export type QueryVendorSalesInvoicesArgs = {
  qop?: InputMaybe<VendorSalesInvoiceQopInput>;
};


export type QueryVendorStockByBranchArgs = {
  qop?: InputMaybe<VendorStockByBranchQopInput>;
};

export type Sort = {
  direction?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
};

export type Vendor = {
  __typename?: 'Vendor';
  vendorID: Scalars['UUID']['output'];
};

export type VendorSalesDashboard = {
  __typename?: 'VendorSalesDashboard';
  salesByBranch: Array<VendorSalesDashboardBranchPoint>;
  summary: VendorSalesDashboardSummary;
  topProducts: Array<VendorSalesDashboardProductPoint>;
  topProductsByRevenue: Array<VendorSalesDashboardProductPoint>;
};

export type VendorSalesDashboardBranchPoint = {
  __typename?: 'VendorSalesDashboardBranchPoint';
  branchID: Scalars['UUID']['output'];
  grossSales: Scalars['Float']['output'];
  invoiceCount: Scalars['Int']['output'];
  vendorShareAmount: Scalars['Float']['output'];
};

export type VendorSalesDashboardFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  dateEnd?: InputMaybe<Scalars['Time']['input']>;
  dateStart?: InputMaybe<Scalars['Time']['input']>;
};

export type VendorSalesDashboardProductPoint = {
  __typename?: 'VendorSalesDashboardProductPoint';
  grossSales: Scalars['Float']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  vendorShareAmount: Scalars['Float']['output'];
};

export type VendorSalesDashboardSummary = {
  __typename?: 'VendorSalesDashboardSummary';
  commissionAmount: Scalars['Float']['output'];
  /** Commission plus its tax; the display value for the Total Komisi KPI. */
  commissionInclTaxAmount: Scalars['Float']['output'];
  /** qty x unit price, before discount. */
  grossSales: Scalars['Float']['output'];
  invoiceCount: Scalars['Int']['output'];
  unitsSold: Scalars['Float']['output'];
  vendorShareAmount: Scalars['Float']['output'];
};

/**
 * Same filters as vendorSalesInvoices, so the file matches the list the vendor is
 * looking at. The vendor is always taken from the token; there is no vendorID here.
 *
 * dateStart and dateEnd are branch wall-clock days, compared to businessDate directly.
 */
export type VendorSalesExportFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  dateEnd?: InputMaybe<Scalars['Time']['input']>;
  dateStart?: InputMaybe<Scalars['Time']['input']>;
  /** Matches the consignment invoice number. */
  salesConsignmentInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type VendorSalesExportResult = {
  __typename?: 'VendorSalesExportResult';
  /** Short-lived signed URL to download the generated .xlsx from object storage. */
  downloadURL: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

/**
 * A vendor's consignment sales, served from this service's own read-model instead of the
 * transaction database. The figures mean exactly what the portal already shows: grossSales is
 * qty x unit price before discount, and the vendor's share is what POS recorded.
 *
 * The vendor is always taken from the token; there is no vendorID argument to get wrong.
 */
export type VendorSalesInvoice = {
  __typename?: 'VendorSalesInvoice';
  branchID: Scalars['UUID']['output'];
  /** The branch-local calendar date of the sale, YYYY-MM-DD. Period filters use this, not the instant. */
  businessDate: Scalars['String']['output'];
  commissionAmount: Scalars['Float']['output'];
  consignmentCommissionFeePerc: Scalars['Float']['output'];
  consignmentPartnershipType: Scalars['String']['output'];
  consignmentVendorID: Scalars['UUID']['output'];
  consignmentVendorTotal: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  gmt: Scalars['Int']['output'];
  salesChannelID: Scalars['String']['output'];
  salesChannelName: Scalars['String']['output'];
  salesConsignmentInvoiceDatetime: Scalars['Time']['output'];
  salesConsignmentInvoiceDatetimeUtc: Scalars['Time']['output'];
  salesConsignmentInvoiceID: Scalars['UUID']['output'];
  salesConsignmentInvoiceNumber: Scalars['String']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  subtotalAfterDiscount: Scalars['Float']['output'];
  /** When this copy last caught up with the transaction service. Shown so a stale screen is visible. */
  syncedAt: Scalars['Time']['output'];
  taxAmount: Scalars['Float']['output'];
  taxIncluded: Scalars['Boolean']['output'];
  taxableAmount: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  totalItemQty: Scalars['Float']['output'];
};

export type VendorSalesInvoiceDetail = {
  __typename?: 'VendorSalesInvoiceDetail';
  invoice: VendorSalesInvoice;
  items: Array<VendorSalesInvoiceItem>;
};

export type VendorSalesInvoiceItem = {
  __typename?: 'VendorSalesInvoiceItem';
  additionalDiscountAmount: Scalars['Float']['output'];
  additionalDiscountPerc: Scalars['Float']['output'];
  barcode: Scalars['String']['output'];
  baseUomQty: Scalars['Float']['output'];
  branchID: Scalars['UUID']['output'];
  businessDate: Scalars['String']['output'];
  commissionAmount: Scalars['Float']['output'];
  consignmentVendorTotal: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  /** Raw jsonb of the tiered percentages, as text. Empty when the line has none. */
  discountPercPlus: Scalars['String']['output'];
  discountType: Scalars['String']['output'];
  productCategoryFullName: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  salesConsignmentInvoiceID: Scalars['UUID']['output'];
  salesConsignmentInvoiceItemID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  taxAmount: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  uomName: Scalars['String']['output'];
};

export type VendorSalesInvoiceItemPaged = {
  __typename?: 'VendorSalesInvoiceItemPaged';
  items: Array<VendorSalesInvoiceItemWithInvoice>;
  pagination: PaginationResult;
};

export type VendorSalesInvoiceItemQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  dateEnd?: InputMaybe<Scalars['Time']['input']>;
  dateStart?: InputMaybe<Scalars['Time']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  salesConsignmentInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  /** Matches product name, product code or barcode. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type VendorSalesInvoiceItemQopInput = {
  filters?: InputMaybe<VendorSalesInvoiceItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
};

/** One item line with the receipt it belongs to, for the item-level sales view. */
export type VendorSalesInvoiceItemWithInvoice = {
  __typename?: 'VendorSalesInvoiceItemWithInvoice';
  invoice: VendorSalesInvoice;
  item: VendorSalesInvoiceItem;
};

export type VendorSalesInvoicePaged = {
  __typename?: 'VendorSalesInvoicePaged';
  items: Array<VendorSalesInvoice>;
  pagination: PaginationResult;
};

/**
 * dateStart and dateEnd are branch wall-clock days: their calendar date is compared to
 * businessDate directly. CONTRACT: send the day the vendor sees, not a converted instant.
 */
export type VendorSalesInvoiceQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  dateEnd?: InputMaybe<Scalars['Time']['input']>;
  dateStart?: InputMaybe<Scalars['Time']['input']>;
  /** Matches the consignment invoice number or the POS receipt number. */
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type VendorSalesInvoiceQopInput = {
  filters?: InputMaybe<VendorSalesInvoiceQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

/**
 * A vendor's consignment stock, one row per (cabang, produk), read live from the inventory and
 * masterdata services over gRPC. Nothing is copied into this service: stock is the one figure a
 * vendor checks against the physical shelf, so a stale copy would be worse than a slower query.
 *
 * Only the branch's sellable (storage) warehouse is counted, which is what the portal has always
 * asked for. Transit stock is deliberately excluded: goods still moving are not on the shelf.
 */
export type VendorStockBranchItem = {
  __typename?: 'VendorStockBranchItem';
  barcode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  imageSmallURL: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  /** Total recorded stock, before commitments and rejects are taken out. */
  qty: Scalars['Float']['output'];
  /** What a customer could actually buy right now: on hand minus committed. */
  qtyAvailable: Scalars['Float']['output'];
  /** Reserved by an order that has not left yet. */
  qtyCommitted: Scalars['Float']['output'];
  qtyOnHand: Scalars['Float']['output'];
  /** Counted as damaged or otherwise not sellable. */
  qtyRejected: Scalars['Float']['output'];
  sellingPrice: Scalars['Float']['output'];
  uomName: Scalars['String']['output'];
};

export type VendorStockBranchPaged = {
  __typename?: 'VendorStockBranchPaged';
  items: Array<VendorStockBranchItem>;
  pagination: PaginationResult;
};

export type VendorStockByBranchQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  /** Hide rows whose available quantity is zero or less. */
  onlyInStock?: InputMaybe<Scalars['Boolean']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  /** Matches product name, product code or barcode. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type VendorStockByBranchQopInput = {
  filters?: InputMaybe<VendorStockByBranchQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  warehouseID: Scalars['UUID']['output'];
};

export type WarehouseLocation = {
  __typename?: 'WarehouseLocation';
  warehouseLocationID: Scalars['UUID']['output'];
};

export const ConsignmentAdminTeamFieldsFragmentDoc = gql`
    fragment ConsignmentAdminTeamFields on ConsignmentTeam {
  consignmentTeamID
  teamName
  sampleAddress
  whatsappContact
  status
  members {
    consignmentTeamMemberID
    userID
    userName
    userActive
  }
  activeMemberCount
  storeCount
  vendorCount
  openRegistrationCount
  used
  entityAuditMetadata {
    createdByUserName
    createdAt
    updatedByUserName
    updatedAt
    version
  }
}
    `;
export const ConsignmentBranchSettingFieldsFragmentDoc = gql`
    fragment ConsignmentBranchSettingFields on ConsignmentStoreSetting {
  branchID
  branchCode
  branchName
  branchActive
  canTakeConsignment
  openToNewVendors
  region {
    consignmentRegionID
    regionName
  }
  team {
    consignmentTeamID
    teamName
  }
  latitude
  longitude
  coordinateStatus
  readiness
  notReadyReason
  version
  entityAuditMetadata {
    createdByUserName
    createdAt
    updatedByUserName
    updatedAt
    version
  }
}
    `;
export const ConsignmentCurationIntSettingFieldsFragmentDoc = gql`
    fragment ConsignmentCurationIntSettingFields on ConsignmentSetupIntSetting {
  settingKey
  value
  min
  max
  version
  updatedAt
  updatedByUserName
}
    `;
export const ConsignmentCurationFieldsFragmentDoc = gql`
    fragment ConsignmentCurationFields on ConsignmentCuration {
  perishableThresholds {
    consignmentCurationPerishableThresholdID
    productType
    productTypeName
    canBePerishable
    shelfLifeUnderDays
    entityAuditMetadata {
      version
    }
  }
  regionMethods {
    consignmentRegionID
    regionName
    perishableCurationMethod
    nonPerishableCurationMethod
    curationMethodIsDefault
    entityAuditMetadata {
      version
    }
  }
  defaultCommission {
    ...ConsignmentCurationIntSettingFields
  }
}
    ${ConsignmentCurationIntSettingFieldsFragmentDoc}`;
export const ConsignmentRegionFieldsFragmentDoc = gql`
    fragment ConsignmentRegionFields on ConsignmentRegion {
  consignmentRegionID
  regionName
  storeCount
  entityAuditMetadata {
    createdByUserName
    createdAt
    updatedByUserName
    updatedAt
    version
  }
}
    `;
export const ConsignmentRegistrationClaimStateFieldsFragmentDoc = gql`
    fragment ConsignmentRegistrationClaimStateFields on ConsignmentRegistrationClaimState {
  consignmentRegistrationID
  registrationNumber
  claimedByUserID
  claimedByUserName
  claimedByMe
}
    `;
export const ConsignmentCurationBlockerFieldsFragmentDoc = gql`
    fragment ConsignmentCurationBlockerFields on ConsignmentCurationBlocker {
  kind
  refID
  message
}
    `;
export const ConsignmentRegistrationCurationFieldsFragmentDoc = gql`
    fragment ConsignmentRegistrationCurationFields on ConsignmentRegistrationCuration {
  consignmentRegistrationID
  version
  stage
  sampleRequiredCount
  sampleReceivedCount
  defaultCommissionPct
  publishedAt
  publishedByUserName
  commissionReason
  vendorNote
  endReason
  reapplyFrom
  blockers {
    ...ConsignmentCurationBlockerFields
  }
  products {
    consignmentRegistrationProductID
    version
    lineNumber
    productName
    sellingPrice
    barcode
    barcodeCheck
    productTypeName
    productCategoryName
    vendorSubCategoryName
    proposedSubCategory
    subCategoryID
    subCategoryName
    subCategoryOptions {
      subCategoryID
      subCategoryName
      productCategoryName
    }
    storageType
    shelfLifeDays
    permitType
    permitNumber
    description
    needsPermitCheck
    photos {
      url
      expiresAt
    }
    curationMethod
    sampleReceived
    sampleReceivedAt
    sampleReceivedByUserName
    sampleConditionNote
    sampleStatus
    sampleShipment {
      packageID
      method
      shippedAt
      qty
      trackingNo
      photos {
        url
        expiresAt
        mimeType
      }
      shippedToTeamName
      shippedToAddress
    }
    verdict
    rejectReason
    rejectReasonLabel
    rejectNote
    allocatedStoreIDs
    labelName
  }
  stores {
    consignmentRegistrationStoreID
    branchID
    branchName
    distanceKm
    ready
    notReadyReason
    approvedProductCount
    result
    commissionType
    commissionPct
  }
}
    ${ConsignmentCurationBlockerFieldsFragmentDoc}`;
export const ConsignmentRegistrationHistoryFieldsFragmentDoc = gql`
    fragment ConsignmentRegistrationHistoryFields on ConsignmentRegistrationHistory {
  totalCount
  entries {
    consignmentRegistrationHistoryID
    at
    actorType
    actorName
    action
    fromStage
    toStage
    reason
    detail
  }
}
    `;
export const ConsignmentRequestDetailFieldsFragmentDoc = gql`
    fragment ConsignmentRequestDetailFields on ConsignmentRegistrationDetail {
  consignmentRegistrationID
  registrationNumber
  viewMode
  stage
  primaryStatus
  teamID
  teamName
  claimedByUserID
  claimedByUserName
  claimedByMe
  isMyTeam
  submittedAt
  stageChangedAt
  ageDays
  inStageDays
  reapplyFrom
  stageDeadlineDate
  vendor {
    businessName
    entityType
    brandName
    provinceName
    cityName
    districtName
    addressLine
    phoneNumberMasked
    targetStoreCount
    productCount
    brandOwnership
    email
    instagram
    tiktok
    heardFrom
    heardFromDetail
  }
  routing {
    nearestStoreName
    nearestDistanceKm
    reason
    routedFromCityCentroid
  }
  flags {
    kind
    refConsignmentRegistrationID
    refRegistrationNumber
    refStage
    refDate
    refVendorCode
    refVendorName
  }
}
    `;
export const ConsignmentRequestListChipCountFieldsFragmentDoc = gql`
    fragment ConsignmentRequestListChipCountFields on ConsignmentRegistrationQueueChipCounts {
  all
  unclaimed
  claimedByMe
  waitingOnTeam
  waitingOnVendor
  activationNotFinished
  done
}
    `;
export const ConsignmentRequestListItemFieldsFragmentDoc = gql`
    fragment ConsignmentRequestListItemFields on ConsignmentRegistrationQueueItem {
  consignmentRegistrationID
  registrationNumber
  vendorName
  teamID
  teamName
  routing {
    nearestStoreName
    nearestDistanceKm
    routedFromCityCentroid
  }
  ageDays
  inStageDays
  claimedByUserID
  claimedByUserName
  claimedByMe
  isMyTeam
  stage
  primaryStatus
}
    `;
export const ConsignmentSetupIntSettingFieldsFragmentDoc = gql`
    fragment ConsignmentSetupIntSettingFields on ConsignmentSetupIntSetting {
  settingKey
  value
  min
  max
  version
  updatedAt
  updatedByUserName
}
    `;
export const ConsignmentSetupContractFieldsFragmentDoc = gql`
    fragment ConsignmentSetupContractFields on ConsignmentSetupContract {
  completeDataDays {
    ...ConsignmentSetupIntSettingFields
  }
  defaultAgreementMonths {
    ...ConsignmentSetupIntSettingFields
  }
  signContractDays {
    ...ConsignmentSetupIntSettingFields
  }
}
    ${ConsignmentSetupIntSettingFieldsFragmentDoc}`;
export const ConsignmentSetupContactSettingFieldsFragmentDoc = gql`
    fragment ConsignmentSetupContactSettingFields on ConsignmentSetupContactSetting {
  settingKey
  value
  version
  updatedAt
  updatedByUserName
}
    `;
export const ConsignmentSetupRegistrationFieldsFragmentDoc = gql`
    fragment ConsignmentSetupRegistrationFields on ConsignmentSetupRegistration {
  productsPerRegistration {
    ...ConsignmentSetupIntSettingFields
  }
  reapplyWaitDays {
    ...ConsignmentSetupIntSettingFields
  }
  resellerContactWa {
    ...ConsignmentSetupContactSettingFields
  }
  partnerSupportContactWa {
    ...ConsignmentSetupContactSettingFields
  }
  registrationAccess {
    settingKey
    value
    effectiveValue
    version
    updatedAt
    updatedByUserName
  }
}
    ${ConsignmentSetupIntSettingFieldsFragmentDoc}
${ConsignmentSetupContactSettingFieldsFragmentDoc}`;
export const ConsignmentVendorApplicationInviteFieldsFragmentDoc = gql`
    fragment ConsignmentVendorApplicationInviteFields on ConsignmentPilotInvite {
  consignmentPilotInviteID
  phoneNumberMasked
  businessName
  source
  status
  registrationNumber
  entityAuditMetadata {
    createdAt
    createdByUserName
  }
}
    `;
export const ConsignmentVendorApplicationInviteImportRowFieldsFragmentDoc = gql`
    fragment ConsignmentVendorApplicationInviteImportRowFields on ConsignmentPilotInviteImportRow {
  rowNumber
  phoneNumberMasked
  businessName
  status
  reasons
}
    `;
export const ConsignmentAdminTeamCreateDocument = gql`
    mutation ConsignmentAdminTeamCreate($input: ConsignmentTeamCreateInput!) {
  consignmentTeamCreate(input: $input) {
    ...ConsignmentAdminTeamFields
  }
}
    ${ConsignmentAdminTeamFieldsFragmentDoc}`;

export function useConsignmentAdminTeamCreateMutation() {
  return Urql.useMutation<ConsignmentAdminTeamCreateMutation, ConsignmentAdminTeamCreateMutationVariables>(ConsignmentAdminTeamCreateDocument);
};
export const ConsignmentAdminTeamDeleteDocument = gql`
    mutation ConsignmentAdminTeamDelete($consignmentTeamID: UUID!) {
  consignmentTeamDelete(consignmentTeamID: $consignmentTeamID)
}
    `;

export function useConsignmentAdminTeamDeleteMutation() {
  return Urql.useMutation<ConsignmentAdminTeamDeleteMutation, ConsignmentAdminTeamDeleteMutationVariables>(ConsignmentAdminTeamDeleteDocument);
};
export const ConsignmentAdminTeamListDocument = gql`
    query ConsignmentAdminTeamList($qop: ConsignmentTeamQopInput) {
  consignmentTeams(qop: $qop) {
    items {
      ...ConsignmentAdminTeamFields
    }
    pagination {
      page
      pageSize
      totalRows
      hasNext
    }
  }
}
    ${ConsignmentAdminTeamFieldsFragmentDoc}`;

export function useConsignmentAdminTeamListQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentAdminTeamListQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentAdminTeamListQuery, ConsignmentAdminTeamListQueryVariables>({ query: ConsignmentAdminTeamListDocument, ...options });
};
export const ConsignmentAdminTeamUpdateDocument = gql`
    mutation ConsignmentAdminTeamUpdate($input: ConsignmentTeamUpdateInput!) {
  consignmentTeamUpdate(input: $input) {
    ...ConsignmentAdminTeamFields
  }
}
    ${ConsignmentAdminTeamFieldsFragmentDoc}`;

export function useConsignmentAdminTeamUpdateMutation() {
  return Urql.useMutation<ConsignmentAdminTeamUpdateMutation, ConsignmentAdminTeamUpdateMutationVariables>(ConsignmentAdminTeamUpdateDocument);
};
export const ConsignmentBranchSettingListDocument = gql`
    query ConsignmentBranchSettingList($qop: ConsignmentStoreSettingQopInput) {
  consignmentStoreSettings(qop: $qop) {
    items {
      ...ConsignmentBranchSettingFields
    }
    pagination {
      page
      pageSize
      totalRows
      hasNext
    }
  }
}
    ${ConsignmentBranchSettingFieldsFragmentDoc}`;

export function useConsignmentBranchSettingListQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentBranchSettingListQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentBranchSettingListQuery, ConsignmentBranchSettingListQueryVariables>({ query: ConsignmentBranchSettingListDocument, ...options });
};
export const ConsignmentBranchSettingStatsDocument = gql`
    query ConsignmentBranchSettingStats {
  allStores: consignmentStoreSettings(
    qop: {pagination: {page: 1, pageSize: 1, withCount: true}}
  ) {
    pagination {
      totalRows
    }
  }
  readyStores: consignmentStoreSettings(
    qop: {pagination: {page: 1, pageSize: 1, withCount: true}, filters: {readiness: READY}}
  ) {
    pagination {
      totalRows
    }
  }
  activeTeams: consignmentTeams(
    qop: {pagination: {page: 1, pageSize: 1, withCount: true}, filters: {status: ACTIVE}}
  ) {
    pagination {
      totalRows
    }
  }
}
    `;

export function useConsignmentBranchSettingStatsQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentBranchSettingStatsQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentBranchSettingStatsQuery, ConsignmentBranchSettingStatsQueryVariables>({ query: ConsignmentBranchSettingStatsDocument, ...options });
};
export const ConsignmentBranchSettingUpdateDocument = gql`
    mutation ConsignmentBranchSettingUpdate($input: ConsignmentStoreSettingUpdateInput!) {
  consignmentStoreSettingUpdate(input: $input) {
    changed
    store {
      ...ConsignmentBranchSettingFields
    }
  }
}
    ${ConsignmentBranchSettingFieldsFragmentDoc}`;

export function useConsignmentBranchSettingUpdateMutation() {
  return Urql.useMutation<ConsignmentBranchSettingUpdateMutation, ConsignmentBranchSettingUpdateMutationVariables>(ConsignmentBranchSettingUpdateDocument);
};
export const ConsignmentCurationDocument = gql`
    query ConsignmentCuration {
  consignmentCuration {
    ...ConsignmentCurationFields
  }
}
    ${ConsignmentCurationFieldsFragmentDoc}`;

export function useConsignmentCurationQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentCurationQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentCurationQuery, ConsignmentCurationQueryVariables>({ query: ConsignmentCurationDocument, ...options });
};
export const ConsignmentCurationUpdateDocument = gql`
    mutation ConsignmentCurationUpdate($input: ConsignmentCurationUpdateInput!) {
  consignmentCurationUpdate(input: $input) {
    changed
    curation {
      ...ConsignmentCurationFields
    }
  }
}
    ${ConsignmentCurationFieldsFragmentDoc}`;

export function useConsignmentCurationUpdateMutation() {
  return Urql.useMutation<ConsignmentCurationUpdateMutation, ConsignmentCurationUpdateMutationVariables>(ConsignmentCurationUpdateDocument);
};
export const ConsignmentProductRequestDetailDocument = gql`
    query ConsignmentProductRequestDetail($consignmentProductRequestID: UUID!) {
  consignmentProductRequest(
    consignmentProductRequestID: $consignmentProductRequestID
  ) {
    consignmentProductRequestID
    requestCode
    requestType
    requestDatetime
    vendorID
    vendorCode
    vendorName
    productID
    productCode
    proposedProductName
    proposedCategory
    proposedBarcode
    proposedPackaging
    proposedSellingPrice
    proposedWeightGram
    proposedShelfLife
    proposedDescription
    changeReason
    productImageFileID
    productImageSmallURL
    productImageMediumURL
    productImageLargeURL
    submittedDatetime
    submittedByUserName
    approvedDatetime
    approvedByUserName
    rejectedDatetime
    rejectedByUserName
    rejectionReason
    noteReviewer
    resultProductID
    status
  }
}
    `;

export function useConsignmentProductRequestDetailQuery(options: Omit<Urql.UseQueryArgs<ConsignmentProductRequestDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentProductRequestDetailQuery, ConsignmentProductRequestDetailQueryVariables>({ query: ConsignmentProductRequestDetailDocument, ...options });
};
export const ConsignmentProductRequestListDocument = gql`
    query ConsignmentProductRequestList($qop: ConsignmentProductRequestQopInput) {
  consignmentProductRequests(qop: $qop) {
    items {
      consignmentProductRequestID
      requestCode
      requestType
      requestDatetime
      vendorID
      vendorCode
      vendorName
      productID
      productCode
      proposedProductName
      proposedCategory
      proposedBarcode
      proposedPackaging
      proposedSellingPrice
      proposedWeightGram
      proposedShelfLife
      proposedDescription
      changeReason
      productImageFileID
      productImageSmallURL
      productImageMediumURL
      productImageLargeURL
      submittedDatetime
      submittedByUserName
      approvedDatetime
      approvedByUserName
      rejectedDatetime
      rejectedByUserName
      rejectionReason
      noteReviewer
      resultProductID
      status
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useConsignmentProductRequestListQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentProductRequestListQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentProductRequestListQuery, ConsignmentProductRequestListQueryVariables>({ query: ConsignmentProductRequestListDocument, ...options });
};
export const ConsignmentProductRequestSummaryDocument = gql`
    query ConsignmentProductRequestSummary($vendorID: UUID) {
  consignmentProductRequestSummary(vendorID: $vendorID) {
    totalRequest
    draft
    submitted
    inReview
    approved
    rejected
    cancelled
  }
}
    `;

export function useConsignmentProductRequestSummaryQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentProductRequestSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentProductRequestSummaryQuery, ConsignmentProductRequestSummaryQueryVariables>({ query: ConsignmentProductRequestSummaryDocument, ...options });
};
export const ConsignmentProductRequestPrepareMasterdataFileDocument = gql`
    mutation ConsignmentProductRequestPrepareMasterdataFile($consignmentProductRequestID: UUID!) {
  consignmentProductRequestPrepareMasterdataFile(
    consignmentProductRequestID: $consignmentProductRequestID
  )
}
    `;

export function useConsignmentProductRequestPrepareMasterdataFileMutation() {
  return Urql.useMutation<ConsignmentProductRequestPrepareMasterdataFileMutation, ConsignmentProductRequestPrepareMasterdataFileMutationVariables>(ConsignmentProductRequestPrepareMasterdataFileDocument);
};
export const ConsignmentProductRequestReviewDocument = gql`
    mutation ConsignmentProductRequestReview($input: ConsignmentProductRequestReviewInput!) {
  consignmentProductRequestReview(input: $input) {
    consignmentProductRequestID
    requestCode
    status
    approvedDatetime
    approvedByUserName
    rejectedDatetime
    rejectedByUserName
    rejectionReason
    noteReviewer
    resultProductID
  }
}
    `;

export function useConsignmentProductRequestReviewMutation() {
  return Urql.useMutation<ConsignmentProductRequestReviewMutation, ConsignmentProductRequestReviewMutationVariables>(ConsignmentProductRequestReviewDocument);
};
export const ConsignmentRegionCreateDocument = gql`
    mutation ConsignmentRegionCreate($input: ConsignmentRegionCreateInput!) {
  consignmentRegionCreate(input: $input) {
    ...ConsignmentRegionFields
  }
}
    ${ConsignmentRegionFieldsFragmentDoc}`;

export function useConsignmentRegionCreateMutation() {
  return Urql.useMutation<ConsignmentRegionCreateMutation, ConsignmentRegionCreateMutationVariables>(ConsignmentRegionCreateDocument);
};
export const ConsignmentRegionDeleteDocument = gql`
    mutation ConsignmentRegionDelete($input: ConsignmentRegionDeleteInput!) {
  consignmentRegionDelete(input: $input)
}
    `;

export function useConsignmentRegionDeleteMutation() {
  return Urql.useMutation<ConsignmentRegionDeleteMutation, ConsignmentRegionDeleteMutationVariables>(ConsignmentRegionDeleteDocument);
};
export const ConsignmentRegionListDocument = gql`
    query ConsignmentRegionList($qop: ConsignmentRegionQopInput) {
  consignmentRegions(qop: $qop) {
    items {
      ...ConsignmentRegionFields
    }
    pagination {
      page
      pageSize
      totalRows
      hasNext
    }
  }
}
    ${ConsignmentRegionFieldsFragmentDoc}`;

export function useConsignmentRegionListQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentRegionListQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentRegionListQuery, ConsignmentRegionListQueryVariables>({ query: ConsignmentRegionListDocument, ...options });
};
export const ConsignmentRegionUpdateDocument = gql`
    mutation ConsignmentRegionUpdate($input: ConsignmentRegionUpdateInput!) {
  consignmentRegionUpdate(input: $input) {
    ...ConsignmentRegionFields
  }
}
    ${ConsignmentRegionFieldsFragmentDoc}`;

export function useConsignmentRegionUpdateMutation() {
  return Urql.useMutation<ConsignmentRegionUpdateMutation, ConsignmentRegionUpdateMutationVariables>(ConsignmentRegionUpdateDocument);
};
export const ConsignmentRegistrationAssignDocument = gql`
    mutation ConsignmentRegistrationAssign($input: ConsignmentRegistrationAssignInput!) {
  consignmentRegistrationAssign(input: $input) {
    ...ConsignmentRegistrationClaimStateFields
  }
}
    ${ConsignmentRegistrationClaimStateFieldsFragmentDoc}`;

export function useConsignmentRegistrationAssignMutation() {
  return Urql.useMutation<ConsignmentRegistrationAssignMutation, ConsignmentRegistrationAssignMutationVariables>(ConsignmentRegistrationAssignDocument);
};
export const ConsignmentRegistrationAssignAllTeamsDocument = gql`
    mutation ConsignmentRegistrationAssignAllTeams($input: ConsignmentRegistrationAssignInput!) {
  consignmentRegistrationAssignAllTeams(input: $input) {
    ...ConsignmentRegistrationClaimStateFields
  }
}
    ${ConsignmentRegistrationClaimStateFieldsFragmentDoc}`;

export function useConsignmentRegistrationAssignAllTeamsMutation() {
  return Urql.useMutation<ConsignmentRegistrationAssignAllTeamsMutation, ConsignmentRegistrationAssignAllTeamsMutationVariables>(ConsignmentRegistrationAssignAllTeamsDocument);
};
export const ConsignmentRegistrationClaimDocument = gql`
    mutation ConsignmentRegistrationClaim($consignmentRegistrationID: UUID!) {
  consignmentRegistrationClaim(
    consignmentRegistrationID: $consignmentRegistrationID
  ) {
    ...ConsignmentRegistrationClaimStateFields
  }
}
    ${ConsignmentRegistrationClaimStateFieldsFragmentDoc}`;

export function useConsignmentRegistrationClaimMutation() {
  return Urql.useMutation<ConsignmentRegistrationClaimMutation, ConsignmentRegistrationClaimMutationVariables>(ConsignmentRegistrationClaimDocument);
};
export const ConsignmentRegistrationCurationDocument = gql`
    query ConsignmentRegistrationCuration($consignmentRegistrationID: UUID!) {
  consignmentRegistrationCuration(
    consignmentRegistrationID: $consignmentRegistrationID
  ) {
    ...ConsignmentRegistrationCurationFields
  }
}
    ${ConsignmentRegistrationCurationFieldsFragmentDoc}`;

export function useConsignmentRegistrationCurationQuery(options: Omit<Urql.UseQueryArgs<ConsignmentRegistrationCurationQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentRegistrationCurationQuery, ConsignmentRegistrationCurationQueryVariables>({ query: ConsignmentRegistrationCurationDocument, ...options });
};
export const ConsignmentRegistrationCurationAllTeamsDocument = gql`
    query ConsignmentRegistrationCurationAllTeams($consignmentRegistrationID: UUID!) {
  consignmentRegistrationCurationAllTeams(
    consignmentRegistrationID: $consignmentRegistrationID
  ) {
    ...ConsignmentRegistrationCurationFields
  }
}
    ${ConsignmentRegistrationCurationFieldsFragmentDoc}`;

export function useConsignmentRegistrationCurationAllTeamsQuery(options: Omit<Urql.UseQueryArgs<ConsignmentRegistrationCurationAllTeamsQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentRegistrationCurationAllTeamsQuery, ConsignmentRegistrationCurationAllTeamsQueryVariables>({ query: ConsignmentRegistrationCurationAllTeamsDocument, ...options });
};
export const ConsignmentRegistrationCurationBarcodeCheckDocument = gql`
    mutation ConsignmentRegistrationCurationBarcodeCheck($consignmentRegistrationID: UUID!) {
  consignmentRegistrationCurationBarcodeCheck(
    consignmentRegistrationID: $consignmentRegistrationID
  ) {
    ...ConsignmentRegistrationCurationFields
  }
}
    ${ConsignmentRegistrationCurationFieldsFragmentDoc}`;

export function useConsignmentRegistrationCurationBarcodeCheckMutation() {
  return Urql.useMutation<ConsignmentRegistrationCurationBarcodeCheckMutation, ConsignmentRegistrationCurationBarcodeCheckMutationVariables>(ConsignmentRegistrationCurationBarcodeCheckDocument);
};
export const ConsignmentRegistrationCurationProductDecideDocument = gql`
    mutation ConsignmentRegistrationCurationProductDecide($input: ConsignmentCurationProductDecideInput!) {
  consignmentRegistrationCurationProductDecide(input: $input) {
    ...ConsignmentRegistrationCurationFields
  }
}
    ${ConsignmentRegistrationCurationFieldsFragmentDoc}`;

export function useConsignmentRegistrationCurationProductDecideMutation() {
  return Urql.useMutation<ConsignmentRegistrationCurationProductDecideMutation, ConsignmentRegistrationCurationProductDecideMutationVariables>(ConsignmentRegistrationCurationProductDecideDocument);
};
export const ConsignmentRegistrationCurationPublishDocument = gql`
    mutation ConsignmentRegistrationCurationPublish($input: ConsignmentCurationPublishInput!) {
  consignmentRegistrationCurationPublish(input: $input) {
    ...ConsignmentRegistrationCurationFields
  }
}
    ${ConsignmentRegistrationCurationFieldsFragmentDoc}`;

export function useConsignmentRegistrationCurationPublishMutation() {
  return Urql.useMutation<ConsignmentRegistrationCurationPublishMutation, ConsignmentRegistrationCurationPublishMutationVariables>(ConsignmentRegistrationCurationPublishDocument);
};
export const ConsignmentRegistrationCurationPublishPreviewDocument = gql`
    query ConsignmentRegistrationCurationPublishPreview($consignmentRegistrationID: UUID!, $vendorNote: String) {
  consignmentRegistrationCurationPublishPreview(
    consignmentRegistrationID: $consignmentRegistrationID
    vendorNote: $vendorNote
  ) {
    willAccept
    approvedProductCount
    totalProductCount
    endReason
    reapplyFrom
    whatsappText
    blockers {
      ...ConsignmentCurationBlockerFields
    }
  }
}
    ${ConsignmentCurationBlockerFieldsFragmentDoc}`;

export function useConsignmentRegistrationCurationPublishPreviewQuery(options: Omit<Urql.UseQueryArgs<ConsignmentRegistrationCurationPublishPreviewQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentRegistrationCurationPublishPreviewQuery, ConsignmentRegistrationCurationPublishPreviewQueryVariables>({ query: ConsignmentRegistrationCurationPublishPreviewDocument, ...options });
};
export const ConsignmentRegistrationHistoryDocument = gql`
    query ConsignmentRegistrationHistory($consignmentRegistrationID: UUID!, $limit: Int) {
  consignmentRegistrationHistory(
    consignmentRegistrationID: $consignmentRegistrationID
    limit: $limit
  ) {
    ...ConsignmentRegistrationHistoryFields
  }
}
    ${ConsignmentRegistrationHistoryFieldsFragmentDoc}`;

export function useConsignmentRegistrationHistoryQuery(options: Omit<Urql.UseQueryArgs<ConsignmentRegistrationHistoryQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentRegistrationHistoryQuery, ConsignmentRegistrationHistoryQueryVariables>({ query: ConsignmentRegistrationHistoryDocument, ...options });
};
export const ConsignmentRegistrationHistoryAllTeamsDocument = gql`
    query ConsignmentRegistrationHistoryAllTeams($consignmentRegistrationID: UUID!, $limit: Int) {
  consignmentRegistrationHistoryAllTeams(
    consignmentRegistrationID: $consignmentRegistrationID
    limit: $limit
  ) {
    ...ConsignmentRegistrationHistoryFields
  }
}
    ${ConsignmentRegistrationHistoryFieldsFragmentDoc}`;

export function useConsignmentRegistrationHistoryAllTeamsQuery(options: Omit<Urql.UseQueryArgs<ConsignmentRegistrationHistoryAllTeamsQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentRegistrationHistoryAllTeamsQuery, ConsignmentRegistrationHistoryAllTeamsQueryVariables>({ query: ConsignmentRegistrationHistoryAllTeamsDocument, ...options });
};
export const ConsignmentRegistrationMoveTeamDocument = gql`
    mutation ConsignmentRegistrationMoveTeam($input: ConsignmentRegistrationMoveTeamInput!) {
  consignmentRegistrationMoveTeam(input: $input) {
    ...ConsignmentRegistrationClaimStateFields
  }
}
    ${ConsignmentRegistrationClaimStateFieldsFragmentDoc}`;

export function useConsignmentRegistrationMoveTeamMutation() {
  return Urql.useMutation<ConsignmentRegistrationMoveTeamMutation, ConsignmentRegistrationMoveTeamMutationVariables>(ConsignmentRegistrationMoveTeamDocument);
};
export const ConsignmentRegistrationMoveTeamPreviewDocument = gql`
    query ConsignmentRegistrationMoveTeamPreview($input: ConsignmentRegistrationMoveTeamPreviewInput!) {
  consignmentRegistrationMoveTeamPreview(input: $input) {
    sampleCase
    currentTeamName
    targetTeamName
    targetSampleAddress
    currentSampleAddress
    shippedSampleCount
    unshippedSampleCount
  }
}
    `;

export function useConsignmentRegistrationMoveTeamPreviewQuery(options: Omit<Urql.UseQueryArgs<ConsignmentRegistrationMoveTeamPreviewQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentRegistrationMoveTeamPreviewQuery, ConsignmentRegistrationMoveTeamPreviewQueryVariables>({ query: ConsignmentRegistrationMoveTeamPreviewDocument, ...options });
};
export const ConsignmentRegistrationProductSwitchToPhotoOnlyDocument = gql`
    mutation ConsignmentRegistrationProductSwitchToPhotoOnly($input: ConsignmentCurationProductSwitchToPhotoOnlyInput!) {
  consignmentRegistrationProductSwitchToPhotoOnly(input: $input) {
    ...ConsignmentRegistrationCurationFields
  }
}
    ${ConsignmentRegistrationCurationFieldsFragmentDoc}`;

export function useConsignmentRegistrationProductSwitchToPhotoOnlyMutation() {
  return Urql.useMutation<ConsignmentRegistrationProductSwitchToPhotoOnlyMutation, ConsignmentRegistrationProductSwitchToPhotoOnlyMutationVariables>(ConsignmentRegistrationProductSwitchToPhotoOnlyDocument);
};
export const ConsignmentRegistrationReleaseDocument = gql`
    mutation ConsignmentRegistrationRelease($consignmentRegistrationID: UUID!) {
  consignmentRegistrationRelease(
    consignmentRegistrationID: $consignmentRegistrationID
  ) {
    ...ConsignmentRegistrationClaimStateFields
  }
}
    ${ConsignmentRegistrationClaimStateFieldsFragmentDoc}`;

export function useConsignmentRegistrationReleaseMutation() {
  return Urql.useMutation<ConsignmentRegistrationReleaseMutation, ConsignmentRegistrationReleaseMutationVariables>(ConsignmentRegistrationReleaseDocument);
};
export const ConsignmentRegistrationSampleReceiveDocument = gql`
    mutation ConsignmentRegistrationSampleReceive($input: ConsignmentCurationSampleReceiveInput!) {
  consignmentRegistrationSampleReceive(input: $input) {
    ...ConsignmentRegistrationCurationFields
  }
}
    ${ConsignmentRegistrationCurationFieldsFragmentDoc}`;

export function useConsignmentRegistrationSampleReceiveMutation() {
  return Urql.useMutation<ConsignmentRegistrationSampleReceiveMutation, ConsignmentRegistrationSampleReceiveMutationVariables>(ConsignmentRegistrationSampleReceiveDocument);
};
export const ConsignmentRegistrationShowFieldDocument = gql`
    mutation ConsignmentRegistrationShowField($consignmentRegistrationID: UUID!, $field: ConsignmentRegistrationSensitiveField!) {
  consignmentRegistrationShowField(
    consignmentRegistrationID: $consignmentRegistrationID
    field: $field
  )
}
    `;

export function useConsignmentRegistrationShowFieldMutation() {
  return Urql.useMutation<ConsignmentRegistrationShowFieldMutation, ConsignmentRegistrationShowFieldMutationVariables>(ConsignmentRegistrationShowFieldDocument);
};
export const ConsignmentRegistrationShowFieldAllTeamsDocument = gql`
    mutation ConsignmentRegistrationShowFieldAllTeams($consignmentRegistrationID: UUID!, $field: ConsignmentRegistrationSensitiveField!) {
  consignmentRegistrationShowFieldAllTeams(
    consignmentRegistrationID: $consignmentRegistrationID
    field: $field
  )
}
    `;

export function useConsignmentRegistrationShowFieldAllTeamsMutation() {
  return Urql.useMutation<ConsignmentRegistrationShowFieldAllTeamsMutation, ConsignmentRegistrationShowFieldAllTeamsMutationVariables>(ConsignmentRegistrationShowFieldAllTeamsDocument);
};
export const ConsignmentRequestDetailDocument = gql`
    query ConsignmentRequestDetail($consignmentRegistrationID: UUID!) {
  consignmentRegistrationDetail(
    consignmentRegistrationID: $consignmentRegistrationID
  ) {
    ...ConsignmentRequestDetailFields
  }
}
    ${ConsignmentRequestDetailFieldsFragmentDoc}`;

export function useConsignmentRequestDetailQuery(options: Omit<Urql.UseQueryArgs<ConsignmentRequestDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentRequestDetailQuery, ConsignmentRequestDetailQueryVariables>({ query: ConsignmentRequestDetailDocument, ...options });
};
export const ConsignmentRequestDetailAllTeamsDocument = gql`
    query ConsignmentRequestDetailAllTeams($consignmentRegistrationID: UUID!) {
  consignmentRegistrationDetailAllTeams(
    consignmentRegistrationID: $consignmentRegistrationID
  ) {
    ...ConsignmentRequestDetailFields
  }
}
    ${ConsignmentRequestDetailFieldsFragmentDoc}`;

export function useConsignmentRequestDetailAllTeamsQuery(options: Omit<Urql.UseQueryArgs<ConsignmentRequestDetailAllTeamsQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentRequestDetailAllTeamsQuery, ConsignmentRequestDetailAllTeamsQueryVariables>({ query: ConsignmentRequestDetailAllTeamsDocument, ...options });
};
export const ConsignmentRequestListDocument = gql`
    query ConsignmentRequestList($qop: ConsignmentRegistrationQueueQopInput) {
  consignmentRegistrationQueue(qop: $qop) {
    items {
      ...ConsignmentRequestListItemFields
    }
    pagination {
      page
      pageSize
      totalRows
      hasNext
    }
  }
}
    ${ConsignmentRequestListItemFieldsFragmentDoc}`;

export function useConsignmentRequestListQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentRequestListQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentRequestListQuery, ConsignmentRequestListQueryVariables>({ query: ConsignmentRequestListDocument, ...options });
};
export const ConsignmentRequestListAllTeamsDocument = gql`
    query ConsignmentRequestListAllTeams($qop: ConsignmentRegistrationQueueQopInput) {
  consignmentRegistrationQueueAllTeams(qop: $qop) {
    items {
      ...ConsignmentRequestListItemFields
    }
    pagination {
      page
      pageSize
      totalRows
      hasNext
    }
  }
}
    ${ConsignmentRequestListItemFieldsFragmentDoc}`;

export function useConsignmentRequestListAllTeamsQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentRequestListAllTeamsQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentRequestListAllTeamsQuery, ConsignmentRequestListAllTeamsQueryVariables>({ query: ConsignmentRequestListAllTeamsDocument, ...options });
};
export const ConsignmentRequestListChipCountsDocument = gql`
    query ConsignmentRequestListChipCounts($teamID: UUID) {
  consignmentRegistrationQueueChipCounts(teamID: $teamID) {
    ...ConsignmentRequestListChipCountFields
  }
}
    ${ConsignmentRequestListChipCountFieldsFragmentDoc}`;

export function useConsignmentRequestListChipCountsQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentRequestListChipCountsQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentRequestListChipCountsQuery, ConsignmentRequestListChipCountsQueryVariables>({ query: ConsignmentRequestListChipCountsDocument, ...options });
};
export const ConsignmentRequestListChipCountsAllTeamsDocument = gql`
    query ConsignmentRequestListChipCountsAllTeams($teamID: UUID) {
  consignmentRegistrationQueueChipCountsAllTeams(teamID: $teamID) {
    ...ConsignmentRequestListChipCountFields
  }
}
    ${ConsignmentRequestListChipCountFieldsFragmentDoc}`;

export function useConsignmentRequestListChipCountsAllTeamsQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentRequestListChipCountsAllTeamsQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentRequestListChipCountsAllTeamsQuery, ConsignmentRequestListChipCountsAllTeamsQueryVariables>({ query: ConsignmentRequestListChipCountsAllTeamsDocument, ...options });
};
export const ConsignmentRegistrationAccessUpdateDocument = gql`
    mutation ConsignmentRegistrationAccessUpdate($input: ConsignmentRegistrationAccessUpdateInput!) {
  consignmentRegistrationAccessUpdate(input: $input) {
    changed
    registration {
      ...ConsignmentSetupRegistrationFields
    }
  }
}
    ${ConsignmentSetupRegistrationFieldsFragmentDoc}`;

export function useConsignmentRegistrationAccessUpdateMutation() {
  return Urql.useMutation<ConsignmentRegistrationAccessUpdateMutation, ConsignmentRegistrationAccessUpdateMutationVariables>(ConsignmentRegistrationAccessUpdateDocument);
};
export const ConsignmentSetupContractDocument = gql`
    query ConsignmentSetupContract {
  consignmentSetupContract {
    ...ConsignmentSetupContractFields
  }
}
    ${ConsignmentSetupContractFieldsFragmentDoc}`;

export function useConsignmentSetupContractQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentSetupContractQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentSetupContractQuery, ConsignmentSetupContractQueryVariables>({ query: ConsignmentSetupContractDocument, ...options });
};
export const ConsignmentSetupContractUpdateDocument = gql`
    mutation ConsignmentSetupContractUpdate($input: ConsignmentSetupContractUpdateInput!) {
  consignmentSetupContractUpdate(input: $input) {
    changed
    contract {
      ...ConsignmentSetupContractFields
    }
  }
}
    ${ConsignmentSetupContractFieldsFragmentDoc}`;

export function useConsignmentSetupContractUpdateMutation() {
  return Urql.useMutation<ConsignmentSetupContractUpdateMutation, ConsignmentSetupContractUpdateMutationVariables>(ConsignmentSetupContractUpdateDocument);
};
export const ConsignmentSetupRegistrationDocument = gql`
    query ConsignmentSetupRegistration {
  consignmentSetupRegistration {
    ...ConsignmentSetupRegistrationFields
  }
}
    ${ConsignmentSetupRegistrationFieldsFragmentDoc}`;

export function useConsignmentSetupRegistrationQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentSetupRegistrationQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentSetupRegistrationQuery, ConsignmentSetupRegistrationQueryVariables>({ query: ConsignmentSetupRegistrationDocument, ...options });
};
export const ConsignmentSetupRegistrationUpdateDocument = gql`
    mutation ConsignmentSetupRegistrationUpdate($input: ConsignmentSetupRegistrationUpdateInput!) {
  consignmentSetupRegistrationUpdate(input: $input) {
    changed
    registration {
      ...ConsignmentSetupRegistrationFields
    }
  }
}
    ${ConsignmentSetupRegistrationFieldsFragmentDoc}`;

export function useConsignmentSetupRegistrationUpdateMutation() {
  return Urql.useMutation<ConsignmentSetupRegistrationUpdateMutation, ConsignmentSetupRegistrationUpdateMutationVariables>(ConsignmentSetupRegistrationUpdateDocument);
};
export const ConsignmentVendorApplicationInviteCreateDocument = gql`
    mutation ConsignmentVendorApplicationInviteCreate($input: ConsignmentPilotInviteCreateInput!) {
  consignmentPilotInviteCreate(input: $input) {
    ...ConsignmentVendorApplicationInviteFields
  }
}
    ${ConsignmentVendorApplicationInviteFieldsFragmentDoc}`;

export function useConsignmentVendorApplicationInviteCreateMutation() {
  return Urql.useMutation<ConsignmentVendorApplicationInviteCreateMutation, ConsignmentVendorApplicationInviteCreateMutationVariables>(ConsignmentVendorApplicationInviteCreateDocument);
};
export const ConsignmentVendorApplicationInviteDeleteDocument = gql`
    mutation ConsignmentVendorApplicationInviteDelete($consignmentPilotInviteID: UUID!) {
  consignmentPilotInviteDelete(
    consignmentPilotInviteID: $consignmentPilotInviteID
  )
}
    `;

export function useConsignmentVendorApplicationInviteDeleteMutation() {
  return Urql.useMutation<ConsignmentVendorApplicationInviteDeleteMutation, ConsignmentVendorApplicationInviteDeleteMutationVariables>(ConsignmentVendorApplicationInviteDeleteDocument);
};
export const ConsignmentVendorApplicationInviteImportDocument = gql`
    mutation ConsignmentVendorApplicationInviteImport($input: ConsignmentPilotInviteImportInput!) {
  consignmentPilotInviteImport(input: $input) {
    importedRows
    skippedRows
    rows {
      ...ConsignmentVendorApplicationInviteImportRowFields
    }
  }
}
    ${ConsignmentVendorApplicationInviteImportRowFieldsFragmentDoc}`;

export function useConsignmentVendorApplicationInviteImportMutation() {
  return Urql.useMutation<ConsignmentVendorApplicationInviteImportMutation, ConsignmentVendorApplicationInviteImportMutationVariables>(ConsignmentVendorApplicationInviteImportDocument);
};
export const ConsignmentVendorApplicationInviteImportPreviewDocument = gql`
    query ConsignmentVendorApplicationInviteImportPreview($input: ConsignmentPilotInviteImportInput!) {
  consignmentPilotInviteImportPreview(input: $input) {
    totalRows
    validRows
    invalidRows
    rows {
      ...ConsignmentVendorApplicationInviteImportRowFields
    }
  }
}
    ${ConsignmentVendorApplicationInviteImportRowFieldsFragmentDoc}`;

export function useConsignmentVendorApplicationInviteImportPreviewQuery(options: Omit<Urql.UseQueryArgs<ConsignmentVendorApplicationInviteImportPreviewQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentVendorApplicationInviteImportPreviewQuery, ConsignmentVendorApplicationInviteImportPreviewQueryVariables>({ query: ConsignmentVendorApplicationInviteImportPreviewDocument, ...options });
};
export const ConsignmentVendorApplicationInviteListDocument = gql`
    query ConsignmentVendorApplicationInviteList($qop: ConsignmentPilotInviteQopInput) {
  consignmentPilotInvites(qop: $qop) {
    items {
      ...ConsignmentVendorApplicationInviteFields
    }
    pagination {
      page
      pageSize
      totalRows
      nextCursor
    }
  }
}
    ${ConsignmentVendorApplicationInviteFieldsFragmentDoc}`;

export function useConsignmentVendorApplicationInviteListQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentVendorApplicationInviteListQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentVendorApplicationInviteListQuery, ConsignmentVendorApplicationInviteListQueryVariables>({ query: ConsignmentVendorApplicationInviteListDocument, ...options });
};
export type ConsignmentAdminTeamCreateMutationVariables = Exact<{
  input: ConsignmentTeamCreateInput;
}>;


export type ConsignmentAdminTeamCreateMutation = { __typename?: 'Mutation', consignmentTeamCreate: { __typename?: 'ConsignmentTeam', consignmentTeamID: any, teamName: string, sampleAddress: string, whatsappContact: string, status: ConsignmentTeamStatus, activeMemberCount: number, storeCount: number, vendorCount: number, openRegistrationCount: number, used: boolean, members: Array<{ __typename?: 'ConsignmentTeamMember', consignmentTeamMemberID: any, userID: any, userName: string, userActive: boolean }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserName?: string | null, createdAt: any, updatedByUserName?: string | null, updatedAt: any, version: any } } };

export type ConsignmentAdminTeamDeleteMutationVariables = Exact<{
  consignmentTeamID: Scalars['UUID']['input'];
}>;


export type ConsignmentAdminTeamDeleteMutation = { __typename?: 'Mutation', consignmentTeamDelete: boolean };

export type ConsignmentAdminTeamFieldsFragment = { __typename?: 'ConsignmentTeam', consignmentTeamID: any, teamName: string, sampleAddress: string, whatsappContact: string, status: ConsignmentTeamStatus, activeMemberCount: number, storeCount: number, vendorCount: number, openRegistrationCount: number, used: boolean, members: Array<{ __typename?: 'ConsignmentTeamMember', consignmentTeamMemberID: any, userID: any, userName: string, userActive: boolean }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserName?: string | null, createdAt: any, updatedByUserName?: string | null, updatedAt: any, version: any } };

export type ConsignmentAdminTeamListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentTeamQopInput>;
}>;


export type ConsignmentAdminTeamListQuery = { __typename?: 'Query', consignmentTeams: { __typename?: 'ConsignmentTeamPaged', items: Array<{ __typename?: 'ConsignmentTeam', consignmentTeamID: any, teamName: string, sampleAddress: string, whatsappContact: string, status: ConsignmentTeamStatus, activeMemberCount: number, storeCount: number, vendorCount: number, openRegistrationCount: number, used: boolean, members: Array<{ __typename?: 'ConsignmentTeamMember', consignmentTeamMemberID: any, userID: any, userName: string, userActive: boolean }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserName?: string | null, createdAt: any, updatedByUserName?: string | null, updatedAt: any, version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ConsignmentAdminTeamUpdateMutationVariables = Exact<{
  input: ConsignmentTeamUpdateInput;
}>;


export type ConsignmentAdminTeamUpdateMutation = { __typename?: 'Mutation', consignmentTeamUpdate: { __typename?: 'ConsignmentTeam', consignmentTeamID: any, teamName: string, sampleAddress: string, whatsappContact: string, status: ConsignmentTeamStatus, activeMemberCount: number, storeCount: number, vendorCount: number, openRegistrationCount: number, used: boolean, members: Array<{ __typename?: 'ConsignmentTeamMember', consignmentTeamMemberID: any, userID: any, userName: string, userActive: boolean }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserName?: string | null, createdAt: any, updatedByUserName?: string | null, updatedAt: any, version: any } } };

export type ConsignmentBranchSettingFieldsFragment = { __typename?: 'ConsignmentStoreSetting', branchID: any, branchCode: string, branchName: string, branchActive: boolean, canTakeConsignment: boolean, openToNewVendors: boolean, latitude: number, longitude: number, coordinateStatus: ConsignmentStoreCoordinateStatus, readiness: ConsignmentStoreReadiness, notReadyReason?: ConsignmentStoreNotReadyReason | null, version?: any | null, region?: { __typename?: 'ConsignmentStoreRegionRef', consignmentRegionID: any, regionName: string } | null, team?: { __typename?: 'ConsignmentStoreTeamRef', consignmentTeamID: any, teamName: string } | null, entityAuditMetadata?: { __typename?: 'EntityAuditMetadata', createdByUserName?: string | null, createdAt: any, updatedByUserName?: string | null, updatedAt: any, version: any } | null };

export type ConsignmentBranchSettingListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStoreSettingQopInput>;
}>;


export type ConsignmentBranchSettingListQuery = { __typename?: 'Query', consignmentStoreSettings: { __typename?: 'ConsignmentStoreSettingPaged', items: Array<{ __typename?: 'ConsignmentStoreSetting', branchID: any, branchCode: string, branchName: string, branchActive: boolean, canTakeConsignment: boolean, openToNewVendors: boolean, latitude: number, longitude: number, coordinateStatus: ConsignmentStoreCoordinateStatus, readiness: ConsignmentStoreReadiness, notReadyReason?: ConsignmentStoreNotReadyReason | null, version?: any | null, region?: { __typename?: 'ConsignmentStoreRegionRef', consignmentRegionID: any, regionName: string } | null, team?: { __typename?: 'ConsignmentStoreTeamRef', consignmentTeamID: any, teamName: string } | null, entityAuditMetadata?: { __typename?: 'EntityAuditMetadata', createdByUserName?: string | null, createdAt: any, updatedByUserName?: string | null, updatedAt: any, version: any } | null }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ConsignmentBranchSettingStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsignmentBranchSettingStatsQuery = { __typename?: 'Query', allStores: { __typename?: 'ConsignmentStoreSettingPaged', pagination: { __typename?: 'PaginationResult', totalRows?: number | null } }, readyStores: { __typename?: 'ConsignmentStoreSettingPaged', pagination: { __typename?: 'PaginationResult', totalRows?: number | null } }, activeTeams: { __typename?: 'ConsignmentTeamPaged', pagination: { __typename?: 'PaginationResult', totalRows?: number | null } } };

export type ConsignmentBranchSettingUpdateMutationVariables = Exact<{
  input: ConsignmentStoreSettingUpdateInput;
}>;


export type ConsignmentBranchSettingUpdateMutation = { __typename?: 'Mutation', consignmentStoreSettingUpdate: { __typename?: 'ConsignmentStoreSettingUpdateResult', changed: boolean, store: { __typename?: 'ConsignmentStoreSetting', branchID: any, branchCode: string, branchName: string, branchActive: boolean, canTakeConsignment: boolean, openToNewVendors: boolean, latitude: number, longitude: number, coordinateStatus: ConsignmentStoreCoordinateStatus, readiness: ConsignmentStoreReadiness, notReadyReason?: ConsignmentStoreNotReadyReason | null, version?: any | null, region?: { __typename?: 'ConsignmentStoreRegionRef', consignmentRegionID: any, regionName: string } | null, team?: { __typename?: 'ConsignmentStoreTeamRef', consignmentTeamID: any, teamName: string } | null, entityAuditMetadata?: { __typename?: 'EntityAuditMetadata', createdByUserName?: string | null, createdAt: any, updatedByUserName?: string | null, updatedAt: any, version: any } | null } } };

export type ConsignmentCurationQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsignmentCurationQuery = { __typename?: 'Query', consignmentCuration: { __typename?: 'ConsignmentCuration', perishableThresholds: Array<{ __typename?: 'ConsignmentCurationPerishableThreshold', consignmentCurationPerishableThresholdID: any, productType: ConsignmentCurationProductType, productTypeName: string, canBePerishable: boolean, shelfLifeUnderDays?: number | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }>, regionMethods: Array<{ __typename?: 'ConsignmentCurationRegionMethod', consignmentRegionID: any, regionName: string, perishableCurationMethod: ConsignmentCurationMethod, nonPerishableCurationMethod: ConsignmentCurationMethod, curationMethodIsDefault: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }>, defaultCommission: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null } } };

export type ConsignmentCurationFieldsFragment = { __typename?: 'ConsignmentCuration', perishableThresholds: Array<{ __typename?: 'ConsignmentCurationPerishableThreshold', consignmentCurationPerishableThresholdID: any, productType: ConsignmentCurationProductType, productTypeName: string, canBePerishable: boolean, shelfLifeUnderDays?: number | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }>, regionMethods: Array<{ __typename?: 'ConsignmentCurationRegionMethod', consignmentRegionID: any, regionName: string, perishableCurationMethod: ConsignmentCurationMethod, nonPerishableCurationMethod: ConsignmentCurationMethod, curationMethodIsDefault: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }>, defaultCommission: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null } };

export type ConsignmentCurationIntSettingFieldsFragment = { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null };

export type ConsignmentCurationUpdateMutationVariables = Exact<{
  input: ConsignmentCurationUpdateInput;
}>;


export type ConsignmentCurationUpdateMutation = { __typename?: 'Mutation', consignmentCurationUpdate: { __typename?: 'ConsignmentCurationUpdateResult', changed: boolean, curation: { __typename?: 'ConsignmentCuration', perishableThresholds: Array<{ __typename?: 'ConsignmentCurationPerishableThreshold', consignmentCurationPerishableThresholdID: any, productType: ConsignmentCurationProductType, productTypeName: string, canBePerishable: boolean, shelfLifeUnderDays?: number | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }>, regionMethods: Array<{ __typename?: 'ConsignmentCurationRegionMethod', consignmentRegionID: any, regionName: string, perishableCurationMethod: ConsignmentCurationMethod, nonPerishableCurationMethod: ConsignmentCurationMethod, curationMethodIsDefault: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }>, defaultCommission: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null } } } };

export type ConsignmentProductRequestDetailQueryVariables = Exact<{
  consignmentProductRequestID: Scalars['UUID']['input'];
}>;


export type ConsignmentProductRequestDetailQuery = { __typename?: 'Query', consignmentProductRequest?: { __typename?: 'ConsignmentProductRequest', consignmentProductRequestID: any, requestCode: string, requestType: string, requestDatetime: any, vendorID: any, vendorCode: string, vendorName: string, productID?: any | null, productCode: string, proposedProductName: string, proposedCategory: string, proposedBarcode: string, proposedPackaging: string, proposedSellingPrice: number, proposedWeightGram: number, proposedShelfLife: string, proposedDescription: string, changeReason: string, productImageFileID?: any | null, productImageSmallURL: string, productImageMediumURL: string, productImageLargeURL: string, submittedDatetime?: any | null, submittedByUserName?: string | null, approvedDatetime?: any | null, approvedByUserName?: string | null, rejectedDatetime?: any | null, rejectedByUserName?: string | null, rejectionReason?: string | null, noteReviewer: string, resultProductID?: any | null, status: string } | null };

export type ConsignmentProductRequestListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentProductRequestQopInput>;
}>;


export type ConsignmentProductRequestListQuery = { __typename?: 'Query', consignmentProductRequests: { __typename?: 'ConsignmentProductRequestPaged', items: Array<{ __typename?: 'ConsignmentProductRequest', consignmentProductRequestID: any, requestCode: string, requestType: string, requestDatetime: any, vendorID: any, vendorCode: string, vendorName: string, productID?: any | null, productCode: string, proposedProductName: string, proposedCategory: string, proposedBarcode: string, proposedPackaging: string, proposedSellingPrice: number, proposedWeightGram: number, proposedShelfLife: string, proposedDescription: string, changeReason: string, productImageFileID?: any | null, productImageSmallURL: string, productImageMediumURL: string, productImageLargeURL: string, submittedDatetime?: any | null, submittedByUserName?: string | null, approvedDatetime?: any | null, approvedByUserName?: string | null, rejectedDatetime?: any | null, rejectedByUserName?: string | null, rejectionReason?: string | null, noteReviewer: string, resultProductID?: any | null, status: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ConsignmentProductRequestSummaryQueryVariables = Exact<{
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ConsignmentProductRequestSummaryQuery = { __typename?: 'Query', consignmentProductRequestSummary: { __typename?: 'ConsignmentProductRequestSummary', totalRequest: number, draft: number, submitted: number, inReview: number, approved: number, rejected: number, cancelled: number } };

export type ConsignmentProductRequestPrepareMasterdataFileMutationVariables = Exact<{
  consignmentProductRequestID: Scalars['UUID']['input'];
}>;


export type ConsignmentProductRequestPrepareMasterdataFileMutation = { __typename?: 'Mutation', consignmentProductRequestPrepareMasterdataFile: string };

export type ConsignmentProductRequestReviewMutationVariables = Exact<{
  input: ConsignmentProductRequestReviewInput;
}>;


export type ConsignmentProductRequestReviewMutation = { __typename?: 'Mutation', consignmentProductRequestReview: { __typename?: 'ConsignmentProductRequest', consignmentProductRequestID: any, requestCode: string, status: string, approvedDatetime?: any | null, approvedByUserName?: string | null, rejectedDatetime?: any | null, rejectedByUserName?: string | null, rejectionReason?: string | null, noteReviewer: string, resultProductID?: any | null } };

export type ConsignmentRegionCreateMutationVariables = Exact<{
  input: ConsignmentRegionCreateInput;
}>;


export type ConsignmentRegionCreateMutation = { __typename?: 'Mutation', consignmentRegionCreate: { __typename?: 'ConsignmentRegion', consignmentRegionID: any, regionName: string, storeCount: number, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserName?: string | null, createdAt: any, updatedByUserName?: string | null, updatedAt: any, version: any } } };

export type ConsignmentRegionDeleteMutationVariables = Exact<{
  input: ConsignmentRegionDeleteInput;
}>;


export type ConsignmentRegionDeleteMutation = { __typename?: 'Mutation', consignmentRegionDelete: boolean };

export type ConsignmentRegionFieldsFragment = { __typename?: 'ConsignmentRegion', consignmentRegionID: any, regionName: string, storeCount: number, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserName?: string | null, createdAt: any, updatedByUserName?: string | null, updatedAt: any, version: any } };

export type ConsignmentRegionListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentRegionQopInput>;
}>;


export type ConsignmentRegionListQuery = { __typename?: 'Query', consignmentRegions: { __typename?: 'ConsignmentRegionPaged', items: Array<{ __typename?: 'ConsignmentRegion', consignmentRegionID: any, regionName: string, storeCount: number, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserName?: string | null, createdAt: any, updatedByUserName?: string | null, updatedAt: any, version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ConsignmentRegionUpdateMutationVariables = Exact<{
  input: ConsignmentRegionUpdateInput;
}>;


export type ConsignmentRegionUpdateMutation = { __typename?: 'Mutation', consignmentRegionUpdate: { __typename?: 'ConsignmentRegion', consignmentRegionID: any, regionName: string, storeCount: number, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserName?: string | null, createdAt: any, updatedByUserName?: string | null, updatedAt: any, version: any } } };

export type ConsignmentCurationBlockerFieldsFragment = { __typename?: 'ConsignmentCurationBlocker', kind: ConsignmentCurationBlockerKind, refID?: any | null, message: string };

export type ConsignmentRegistrationAssignMutationVariables = Exact<{
  input: ConsignmentRegistrationAssignInput;
}>;


export type ConsignmentRegistrationAssignMutation = { __typename?: 'Mutation', consignmentRegistrationAssign: { __typename?: 'ConsignmentRegistrationClaimState', consignmentRegistrationID: any, registrationNumber: string, claimedByUserID?: any | null, claimedByUserName?: string | null, claimedByMe: boolean } };

export type ConsignmentRegistrationAssignAllTeamsMutationVariables = Exact<{
  input: ConsignmentRegistrationAssignInput;
}>;


export type ConsignmentRegistrationAssignAllTeamsMutation = { __typename?: 'Mutation', consignmentRegistrationAssignAllTeams: { __typename?: 'ConsignmentRegistrationClaimState', consignmentRegistrationID: any, registrationNumber: string, claimedByUserID?: any | null, claimedByUserName?: string | null, claimedByMe: boolean } };

export type ConsignmentRegistrationClaimMutationVariables = Exact<{
  consignmentRegistrationID: Scalars['UUID']['input'];
}>;


export type ConsignmentRegistrationClaimMutation = { __typename?: 'Mutation', consignmentRegistrationClaim: { __typename?: 'ConsignmentRegistrationClaimState', consignmentRegistrationID: any, registrationNumber: string, claimedByUserID?: any | null, claimedByUserName?: string | null, claimedByMe: boolean } };

export type ConsignmentRegistrationClaimStateFieldsFragment = { __typename?: 'ConsignmentRegistrationClaimState', consignmentRegistrationID: any, registrationNumber: string, claimedByUserID?: any | null, claimedByUserName?: string | null, claimedByMe: boolean };

export type ConsignmentRegistrationCurationQueryVariables = Exact<{
  consignmentRegistrationID: Scalars['UUID']['input'];
}>;


export type ConsignmentRegistrationCurationQuery = { __typename?: 'Query', consignmentRegistrationCuration: { __typename?: 'ConsignmentRegistrationCuration', consignmentRegistrationID: any, version: any, stage: ConsignmentRegistrationStage, sampleRequiredCount: number, sampleReceivedCount: number, defaultCommissionPct?: number | null, publishedAt?: any | null, publishedByUserName?: string | null, commissionReason?: string | null, vendorNote?: string | null, endReason?: ConsignmentRegistrationEndReason | null, reapplyFrom?: string | null, blockers: Array<{ __typename?: 'ConsignmentCurationBlocker', kind: ConsignmentCurationBlockerKind, refID?: any | null, message: string }>, products: Array<{ __typename?: 'ConsignmentCurationProduct', consignmentRegistrationProductID: any, version: any, lineNumber: number, productName: string, sellingPrice: number, barcode?: string | null, barcodeCheck: ConsignmentCurationBarcodeCheck, productTypeName: string, productCategoryName: string, vendorSubCategoryName?: string | null, proposedSubCategory?: string | null, subCategoryID?: any | null, subCategoryName?: string | null, storageType: string, shelfLifeDays?: number | null, permitType?: string | null, permitNumber?: string | null, description?: string | null, needsPermitCheck: boolean, curationMethod: ConsignmentCurationMethod, sampleReceived: boolean, sampleReceivedAt?: any | null, sampleReceivedByUserName?: string | null, sampleConditionNote?: string | null, sampleStatus: ConsignmentCurationSampleStatus, verdict: ConsignmentCurationVerdict, rejectReason?: ConsignmentCurationRejectReason | null, rejectReasonLabel?: string | null, rejectNote?: string | null, allocatedStoreIDs: Array<any>, labelName?: string | null, subCategoryOptions: Array<{ __typename?: 'ConsignmentCurationSubCategoryOption', subCategoryID: any, subCategoryName: string, productCategoryName: string }>, photos: Array<{ __typename?: 'ConsignmentCurationPhoto', url: string, expiresAt: any }>, sampleShipment?: { __typename?: 'ConsignmentCurationSampleShipment', packageID: any, method: ConsignmentCurationSampleMethod, shippedAt: string, qty?: number | null, trackingNo?: string | null, shippedToTeamName: string, shippedToAddress: string, photos: Array<{ __typename?: 'ConsignmentCurationSampleProof', url: string, expiresAt: any, mimeType: string }> } | null }>, stores: Array<{ __typename?: 'ConsignmentCurationStore', consignmentRegistrationStoreID: any, branchID: any, branchName: string, distanceKm?: number | null, ready: boolean, notReadyReason?: string | null, approvedProductCount: number, result?: ConsignmentCurationStoreResult | null, commissionType?: ConsignmentCurationCommissionType | null, commissionPct?: number | null }> } };

export type ConsignmentRegistrationCurationAllTeamsQueryVariables = Exact<{
  consignmentRegistrationID: Scalars['UUID']['input'];
}>;


export type ConsignmentRegistrationCurationAllTeamsQuery = { __typename?: 'Query', consignmentRegistrationCurationAllTeams: { __typename?: 'ConsignmentRegistrationCuration', consignmentRegistrationID: any, version: any, stage: ConsignmentRegistrationStage, sampleRequiredCount: number, sampleReceivedCount: number, defaultCommissionPct?: number | null, publishedAt?: any | null, publishedByUserName?: string | null, commissionReason?: string | null, vendorNote?: string | null, endReason?: ConsignmentRegistrationEndReason | null, reapplyFrom?: string | null, blockers: Array<{ __typename?: 'ConsignmentCurationBlocker', kind: ConsignmentCurationBlockerKind, refID?: any | null, message: string }>, products: Array<{ __typename?: 'ConsignmentCurationProduct', consignmentRegistrationProductID: any, version: any, lineNumber: number, productName: string, sellingPrice: number, barcode?: string | null, barcodeCheck: ConsignmentCurationBarcodeCheck, productTypeName: string, productCategoryName: string, vendorSubCategoryName?: string | null, proposedSubCategory?: string | null, subCategoryID?: any | null, subCategoryName?: string | null, storageType: string, shelfLifeDays?: number | null, permitType?: string | null, permitNumber?: string | null, description?: string | null, needsPermitCheck: boolean, curationMethod: ConsignmentCurationMethod, sampleReceived: boolean, sampleReceivedAt?: any | null, sampleReceivedByUserName?: string | null, sampleConditionNote?: string | null, sampleStatus: ConsignmentCurationSampleStatus, verdict: ConsignmentCurationVerdict, rejectReason?: ConsignmentCurationRejectReason | null, rejectReasonLabel?: string | null, rejectNote?: string | null, allocatedStoreIDs: Array<any>, labelName?: string | null, subCategoryOptions: Array<{ __typename?: 'ConsignmentCurationSubCategoryOption', subCategoryID: any, subCategoryName: string, productCategoryName: string }>, photos: Array<{ __typename?: 'ConsignmentCurationPhoto', url: string, expiresAt: any }>, sampleShipment?: { __typename?: 'ConsignmentCurationSampleShipment', packageID: any, method: ConsignmentCurationSampleMethod, shippedAt: string, qty?: number | null, trackingNo?: string | null, shippedToTeamName: string, shippedToAddress: string, photos: Array<{ __typename?: 'ConsignmentCurationSampleProof', url: string, expiresAt: any, mimeType: string }> } | null }>, stores: Array<{ __typename?: 'ConsignmentCurationStore', consignmentRegistrationStoreID: any, branchID: any, branchName: string, distanceKm?: number | null, ready: boolean, notReadyReason?: string | null, approvedProductCount: number, result?: ConsignmentCurationStoreResult | null, commissionType?: ConsignmentCurationCommissionType | null, commissionPct?: number | null }> } };

export type ConsignmentRegistrationCurationBarcodeCheckMutationVariables = Exact<{
  consignmentRegistrationID: Scalars['UUID']['input'];
}>;


export type ConsignmentRegistrationCurationBarcodeCheckMutation = { __typename?: 'Mutation', consignmentRegistrationCurationBarcodeCheck: { __typename?: 'ConsignmentRegistrationCuration', consignmentRegistrationID: any, version: any, stage: ConsignmentRegistrationStage, sampleRequiredCount: number, sampleReceivedCount: number, defaultCommissionPct?: number | null, publishedAt?: any | null, publishedByUserName?: string | null, commissionReason?: string | null, vendorNote?: string | null, endReason?: ConsignmentRegistrationEndReason | null, reapplyFrom?: string | null, blockers: Array<{ __typename?: 'ConsignmentCurationBlocker', kind: ConsignmentCurationBlockerKind, refID?: any | null, message: string }>, products: Array<{ __typename?: 'ConsignmentCurationProduct', consignmentRegistrationProductID: any, version: any, lineNumber: number, productName: string, sellingPrice: number, barcode?: string | null, barcodeCheck: ConsignmentCurationBarcodeCheck, productTypeName: string, productCategoryName: string, vendorSubCategoryName?: string | null, proposedSubCategory?: string | null, subCategoryID?: any | null, subCategoryName?: string | null, storageType: string, shelfLifeDays?: number | null, permitType?: string | null, permitNumber?: string | null, description?: string | null, needsPermitCheck: boolean, curationMethod: ConsignmentCurationMethod, sampleReceived: boolean, sampleReceivedAt?: any | null, sampleReceivedByUserName?: string | null, sampleConditionNote?: string | null, sampleStatus: ConsignmentCurationSampleStatus, verdict: ConsignmentCurationVerdict, rejectReason?: ConsignmentCurationRejectReason | null, rejectReasonLabel?: string | null, rejectNote?: string | null, allocatedStoreIDs: Array<any>, labelName?: string | null, subCategoryOptions: Array<{ __typename?: 'ConsignmentCurationSubCategoryOption', subCategoryID: any, subCategoryName: string, productCategoryName: string }>, photos: Array<{ __typename?: 'ConsignmentCurationPhoto', url: string, expiresAt: any }>, sampleShipment?: { __typename?: 'ConsignmentCurationSampleShipment', packageID: any, method: ConsignmentCurationSampleMethod, shippedAt: string, qty?: number | null, trackingNo?: string | null, shippedToTeamName: string, shippedToAddress: string, photos: Array<{ __typename?: 'ConsignmentCurationSampleProof', url: string, expiresAt: any, mimeType: string }> } | null }>, stores: Array<{ __typename?: 'ConsignmentCurationStore', consignmentRegistrationStoreID: any, branchID: any, branchName: string, distanceKm?: number | null, ready: boolean, notReadyReason?: string | null, approvedProductCount: number, result?: ConsignmentCurationStoreResult | null, commissionType?: ConsignmentCurationCommissionType | null, commissionPct?: number | null }> } };

export type ConsignmentRegistrationCurationFieldsFragment = { __typename?: 'ConsignmentRegistrationCuration', consignmentRegistrationID: any, version: any, stage: ConsignmentRegistrationStage, sampleRequiredCount: number, sampleReceivedCount: number, defaultCommissionPct?: number | null, publishedAt?: any | null, publishedByUserName?: string | null, commissionReason?: string | null, vendorNote?: string | null, endReason?: ConsignmentRegistrationEndReason | null, reapplyFrom?: string | null, blockers: Array<{ __typename?: 'ConsignmentCurationBlocker', kind: ConsignmentCurationBlockerKind, refID?: any | null, message: string }>, products: Array<{ __typename?: 'ConsignmentCurationProduct', consignmentRegistrationProductID: any, version: any, lineNumber: number, productName: string, sellingPrice: number, barcode?: string | null, barcodeCheck: ConsignmentCurationBarcodeCheck, productTypeName: string, productCategoryName: string, vendorSubCategoryName?: string | null, proposedSubCategory?: string | null, subCategoryID?: any | null, subCategoryName?: string | null, storageType: string, shelfLifeDays?: number | null, permitType?: string | null, permitNumber?: string | null, description?: string | null, needsPermitCheck: boolean, curationMethod: ConsignmentCurationMethod, sampleReceived: boolean, sampleReceivedAt?: any | null, sampleReceivedByUserName?: string | null, sampleConditionNote?: string | null, sampleStatus: ConsignmentCurationSampleStatus, verdict: ConsignmentCurationVerdict, rejectReason?: ConsignmentCurationRejectReason | null, rejectReasonLabel?: string | null, rejectNote?: string | null, allocatedStoreIDs: Array<any>, labelName?: string | null, subCategoryOptions: Array<{ __typename?: 'ConsignmentCurationSubCategoryOption', subCategoryID: any, subCategoryName: string, productCategoryName: string }>, photos: Array<{ __typename?: 'ConsignmentCurationPhoto', url: string, expiresAt: any }>, sampleShipment?: { __typename?: 'ConsignmentCurationSampleShipment', packageID: any, method: ConsignmentCurationSampleMethod, shippedAt: string, qty?: number | null, trackingNo?: string | null, shippedToTeamName: string, shippedToAddress: string, photos: Array<{ __typename?: 'ConsignmentCurationSampleProof', url: string, expiresAt: any, mimeType: string }> } | null }>, stores: Array<{ __typename?: 'ConsignmentCurationStore', consignmentRegistrationStoreID: any, branchID: any, branchName: string, distanceKm?: number | null, ready: boolean, notReadyReason?: string | null, approvedProductCount: number, result?: ConsignmentCurationStoreResult | null, commissionType?: ConsignmentCurationCommissionType | null, commissionPct?: number | null }> };

export type ConsignmentRegistrationCurationProductDecideMutationVariables = Exact<{
  input: ConsignmentCurationProductDecideInput;
}>;


export type ConsignmentRegistrationCurationProductDecideMutation = { __typename?: 'Mutation', consignmentRegistrationCurationProductDecide: { __typename?: 'ConsignmentRegistrationCuration', consignmentRegistrationID: any, version: any, stage: ConsignmentRegistrationStage, sampleRequiredCount: number, sampleReceivedCount: number, defaultCommissionPct?: number | null, publishedAt?: any | null, publishedByUserName?: string | null, commissionReason?: string | null, vendorNote?: string | null, endReason?: ConsignmentRegistrationEndReason | null, reapplyFrom?: string | null, blockers: Array<{ __typename?: 'ConsignmentCurationBlocker', kind: ConsignmentCurationBlockerKind, refID?: any | null, message: string }>, products: Array<{ __typename?: 'ConsignmentCurationProduct', consignmentRegistrationProductID: any, version: any, lineNumber: number, productName: string, sellingPrice: number, barcode?: string | null, barcodeCheck: ConsignmentCurationBarcodeCheck, productTypeName: string, productCategoryName: string, vendorSubCategoryName?: string | null, proposedSubCategory?: string | null, subCategoryID?: any | null, subCategoryName?: string | null, storageType: string, shelfLifeDays?: number | null, permitType?: string | null, permitNumber?: string | null, description?: string | null, needsPermitCheck: boolean, curationMethod: ConsignmentCurationMethod, sampleReceived: boolean, sampleReceivedAt?: any | null, sampleReceivedByUserName?: string | null, sampleConditionNote?: string | null, sampleStatus: ConsignmentCurationSampleStatus, verdict: ConsignmentCurationVerdict, rejectReason?: ConsignmentCurationRejectReason | null, rejectReasonLabel?: string | null, rejectNote?: string | null, allocatedStoreIDs: Array<any>, labelName?: string | null, subCategoryOptions: Array<{ __typename?: 'ConsignmentCurationSubCategoryOption', subCategoryID: any, subCategoryName: string, productCategoryName: string }>, photos: Array<{ __typename?: 'ConsignmentCurationPhoto', url: string, expiresAt: any }>, sampleShipment?: { __typename?: 'ConsignmentCurationSampleShipment', packageID: any, method: ConsignmentCurationSampleMethod, shippedAt: string, qty?: number | null, trackingNo?: string | null, shippedToTeamName: string, shippedToAddress: string, photos: Array<{ __typename?: 'ConsignmentCurationSampleProof', url: string, expiresAt: any, mimeType: string }> } | null }>, stores: Array<{ __typename?: 'ConsignmentCurationStore', consignmentRegistrationStoreID: any, branchID: any, branchName: string, distanceKm?: number | null, ready: boolean, notReadyReason?: string | null, approvedProductCount: number, result?: ConsignmentCurationStoreResult | null, commissionType?: ConsignmentCurationCommissionType | null, commissionPct?: number | null }> } };

export type ConsignmentRegistrationCurationPublishMutationVariables = Exact<{
  input: ConsignmentCurationPublishInput;
}>;


export type ConsignmentRegistrationCurationPublishMutation = { __typename?: 'Mutation', consignmentRegistrationCurationPublish: { __typename?: 'ConsignmentRegistrationCuration', consignmentRegistrationID: any, version: any, stage: ConsignmentRegistrationStage, sampleRequiredCount: number, sampleReceivedCount: number, defaultCommissionPct?: number | null, publishedAt?: any | null, publishedByUserName?: string | null, commissionReason?: string | null, vendorNote?: string | null, endReason?: ConsignmentRegistrationEndReason | null, reapplyFrom?: string | null, blockers: Array<{ __typename?: 'ConsignmentCurationBlocker', kind: ConsignmentCurationBlockerKind, refID?: any | null, message: string }>, products: Array<{ __typename?: 'ConsignmentCurationProduct', consignmentRegistrationProductID: any, version: any, lineNumber: number, productName: string, sellingPrice: number, barcode?: string | null, barcodeCheck: ConsignmentCurationBarcodeCheck, productTypeName: string, productCategoryName: string, vendorSubCategoryName?: string | null, proposedSubCategory?: string | null, subCategoryID?: any | null, subCategoryName?: string | null, storageType: string, shelfLifeDays?: number | null, permitType?: string | null, permitNumber?: string | null, description?: string | null, needsPermitCheck: boolean, curationMethod: ConsignmentCurationMethod, sampleReceived: boolean, sampleReceivedAt?: any | null, sampleReceivedByUserName?: string | null, sampleConditionNote?: string | null, sampleStatus: ConsignmentCurationSampleStatus, verdict: ConsignmentCurationVerdict, rejectReason?: ConsignmentCurationRejectReason | null, rejectReasonLabel?: string | null, rejectNote?: string | null, allocatedStoreIDs: Array<any>, labelName?: string | null, subCategoryOptions: Array<{ __typename?: 'ConsignmentCurationSubCategoryOption', subCategoryID: any, subCategoryName: string, productCategoryName: string }>, photos: Array<{ __typename?: 'ConsignmentCurationPhoto', url: string, expiresAt: any }>, sampleShipment?: { __typename?: 'ConsignmentCurationSampleShipment', packageID: any, method: ConsignmentCurationSampleMethod, shippedAt: string, qty?: number | null, trackingNo?: string | null, shippedToTeamName: string, shippedToAddress: string, photos: Array<{ __typename?: 'ConsignmentCurationSampleProof', url: string, expiresAt: any, mimeType: string }> } | null }>, stores: Array<{ __typename?: 'ConsignmentCurationStore', consignmentRegistrationStoreID: any, branchID: any, branchName: string, distanceKm?: number | null, ready: boolean, notReadyReason?: string | null, approvedProductCount: number, result?: ConsignmentCurationStoreResult | null, commissionType?: ConsignmentCurationCommissionType | null, commissionPct?: number | null }> } };

export type ConsignmentRegistrationCurationPublishPreviewQueryVariables = Exact<{
  consignmentRegistrationID: Scalars['UUID']['input'];
  vendorNote?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConsignmentRegistrationCurationPublishPreviewQuery = { __typename?: 'Query', consignmentRegistrationCurationPublishPreview: { __typename?: 'ConsignmentCurationPublishPreview', willAccept: boolean, approvedProductCount: number, totalProductCount: number, endReason?: ConsignmentRegistrationEndReason | null, reapplyFrom?: string | null, whatsappText?: string | null, blockers: Array<{ __typename?: 'ConsignmentCurationBlocker', kind: ConsignmentCurationBlockerKind, refID?: any | null, message: string }> } };

export type ConsignmentRegistrationHistoryQueryVariables = Exact<{
  consignmentRegistrationID: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ConsignmentRegistrationHistoryQuery = { __typename?: 'Query', consignmentRegistrationHistory: { __typename?: 'ConsignmentRegistrationHistory', totalCount: number, entries: Array<{ __typename?: 'ConsignmentRegistrationHistoryEntry', consignmentRegistrationHistoryID: any, at: any, actorType: ConsignmentRegistrationActorType, actorName?: string | null, action: string, fromStage?: ConsignmentRegistrationStage | null, toStage?: ConsignmentRegistrationStage | null, reason?: string | null, detail?: string | null }> } };

export type ConsignmentRegistrationHistoryAllTeamsQueryVariables = Exact<{
  consignmentRegistrationID: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ConsignmentRegistrationHistoryAllTeamsQuery = { __typename?: 'Query', consignmentRegistrationHistoryAllTeams: { __typename?: 'ConsignmentRegistrationHistory', totalCount: number, entries: Array<{ __typename?: 'ConsignmentRegistrationHistoryEntry', consignmentRegistrationHistoryID: any, at: any, actorType: ConsignmentRegistrationActorType, actorName?: string | null, action: string, fromStage?: ConsignmentRegistrationStage | null, toStage?: ConsignmentRegistrationStage | null, reason?: string | null, detail?: string | null }> } };

export type ConsignmentRegistrationHistoryFieldsFragment = { __typename?: 'ConsignmentRegistrationHistory', totalCount: number, entries: Array<{ __typename?: 'ConsignmentRegistrationHistoryEntry', consignmentRegistrationHistoryID: any, at: any, actorType: ConsignmentRegistrationActorType, actorName?: string | null, action: string, fromStage?: ConsignmentRegistrationStage | null, toStage?: ConsignmentRegistrationStage | null, reason?: string | null, detail?: string | null }> };

export type ConsignmentRegistrationMoveTeamMutationVariables = Exact<{
  input: ConsignmentRegistrationMoveTeamInput;
}>;


export type ConsignmentRegistrationMoveTeamMutation = { __typename?: 'Mutation', consignmentRegistrationMoveTeam: { __typename?: 'ConsignmentRegistrationClaimState', consignmentRegistrationID: any, registrationNumber: string, claimedByUserID?: any | null, claimedByUserName?: string | null, claimedByMe: boolean } };

export type ConsignmentRegistrationMoveTeamPreviewQueryVariables = Exact<{
  input: ConsignmentRegistrationMoveTeamPreviewInput;
}>;


export type ConsignmentRegistrationMoveTeamPreviewQuery = { __typename?: 'Query', consignmentRegistrationMoveTeamPreview: { __typename?: 'ConsignmentRegistrationMoveTeamPreview', sampleCase: ConsignmentRegistrationMoveTeamSampleCase, currentTeamName: string, targetTeamName: string, targetSampleAddress: string, currentSampleAddress: string, shippedSampleCount: number, unshippedSampleCount: number } };

export type ConsignmentRegistrationProductSwitchToPhotoOnlyMutationVariables = Exact<{
  input: ConsignmentCurationProductSwitchToPhotoOnlyInput;
}>;


export type ConsignmentRegistrationProductSwitchToPhotoOnlyMutation = { __typename?: 'Mutation', consignmentRegistrationProductSwitchToPhotoOnly: { __typename?: 'ConsignmentRegistrationCuration', consignmentRegistrationID: any, version: any, stage: ConsignmentRegistrationStage, sampleRequiredCount: number, sampleReceivedCount: number, defaultCommissionPct?: number | null, publishedAt?: any | null, publishedByUserName?: string | null, commissionReason?: string | null, vendorNote?: string | null, endReason?: ConsignmentRegistrationEndReason | null, reapplyFrom?: string | null, blockers: Array<{ __typename?: 'ConsignmentCurationBlocker', kind: ConsignmentCurationBlockerKind, refID?: any | null, message: string }>, products: Array<{ __typename?: 'ConsignmentCurationProduct', consignmentRegistrationProductID: any, version: any, lineNumber: number, productName: string, sellingPrice: number, barcode?: string | null, barcodeCheck: ConsignmentCurationBarcodeCheck, productTypeName: string, productCategoryName: string, vendorSubCategoryName?: string | null, proposedSubCategory?: string | null, subCategoryID?: any | null, subCategoryName?: string | null, storageType: string, shelfLifeDays?: number | null, permitType?: string | null, permitNumber?: string | null, description?: string | null, needsPermitCheck: boolean, curationMethod: ConsignmentCurationMethod, sampleReceived: boolean, sampleReceivedAt?: any | null, sampleReceivedByUserName?: string | null, sampleConditionNote?: string | null, sampleStatus: ConsignmentCurationSampleStatus, verdict: ConsignmentCurationVerdict, rejectReason?: ConsignmentCurationRejectReason | null, rejectReasonLabel?: string | null, rejectNote?: string | null, allocatedStoreIDs: Array<any>, labelName?: string | null, subCategoryOptions: Array<{ __typename?: 'ConsignmentCurationSubCategoryOption', subCategoryID: any, subCategoryName: string, productCategoryName: string }>, photos: Array<{ __typename?: 'ConsignmentCurationPhoto', url: string, expiresAt: any }>, sampleShipment?: { __typename?: 'ConsignmentCurationSampleShipment', packageID: any, method: ConsignmentCurationSampleMethod, shippedAt: string, qty?: number | null, trackingNo?: string | null, shippedToTeamName: string, shippedToAddress: string, photos: Array<{ __typename?: 'ConsignmentCurationSampleProof', url: string, expiresAt: any, mimeType: string }> } | null }>, stores: Array<{ __typename?: 'ConsignmentCurationStore', consignmentRegistrationStoreID: any, branchID: any, branchName: string, distanceKm?: number | null, ready: boolean, notReadyReason?: string | null, approvedProductCount: number, result?: ConsignmentCurationStoreResult | null, commissionType?: ConsignmentCurationCommissionType | null, commissionPct?: number | null }> } };

export type ConsignmentRegistrationReleaseMutationVariables = Exact<{
  consignmentRegistrationID: Scalars['UUID']['input'];
}>;


export type ConsignmentRegistrationReleaseMutation = { __typename?: 'Mutation', consignmentRegistrationRelease: { __typename?: 'ConsignmentRegistrationClaimState', consignmentRegistrationID: any, registrationNumber: string, claimedByUserID?: any | null, claimedByUserName?: string | null, claimedByMe: boolean } };

export type ConsignmentRegistrationSampleReceiveMutationVariables = Exact<{
  input: ConsignmentCurationSampleReceiveInput;
}>;


export type ConsignmentRegistrationSampleReceiveMutation = { __typename?: 'Mutation', consignmentRegistrationSampleReceive: { __typename?: 'ConsignmentRegistrationCuration', consignmentRegistrationID: any, version: any, stage: ConsignmentRegistrationStage, sampleRequiredCount: number, sampleReceivedCount: number, defaultCommissionPct?: number | null, publishedAt?: any | null, publishedByUserName?: string | null, commissionReason?: string | null, vendorNote?: string | null, endReason?: ConsignmentRegistrationEndReason | null, reapplyFrom?: string | null, blockers: Array<{ __typename?: 'ConsignmentCurationBlocker', kind: ConsignmentCurationBlockerKind, refID?: any | null, message: string }>, products: Array<{ __typename?: 'ConsignmentCurationProduct', consignmentRegistrationProductID: any, version: any, lineNumber: number, productName: string, sellingPrice: number, barcode?: string | null, barcodeCheck: ConsignmentCurationBarcodeCheck, productTypeName: string, productCategoryName: string, vendorSubCategoryName?: string | null, proposedSubCategory?: string | null, subCategoryID?: any | null, subCategoryName?: string | null, storageType: string, shelfLifeDays?: number | null, permitType?: string | null, permitNumber?: string | null, description?: string | null, needsPermitCheck: boolean, curationMethod: ConsignmentCurationMethod, sampleReceived: boolean, sampleReceivedAt?: any | null, sampleReceivedByUserName?: string | null, sampleConditionNote?: string | null, sampleStatus: ConsignmentCurationSampleStatus, verdict: ConsignmentCurationVerdict, rejectReason?: ConsignmentCurationRejectReason | null, rejectReasonLabel?: string | null, rejectNote?: string | null, allocatedStoreIDs: Array<any>, labelName?: string | null, subCategoryOptions: Array<{ __typename?: 'ConsignmentCurationSubCategoryOption', subCategoryID: any, subCategoryName: string, productCategoryName: string }>, photos: Array<{ __typename?: 'ConsignmentCurationPhoto', url: string, expiresAt: any }>, sampleShipment?: { __typename?: 'ConsignmentCurationSampleShipment', packageID: any, method: ConsignmentCurationSampleMethod, shippedAt: string, qty?: number | null, trackingNo?: string | null, shippedToTeamName: string, shippedToAddress: string, photos: Array<{ __typename?: 'ConsignmentCurationSampleProof', url: string, expiresAt: any, mimeType: string }> } | null }>, stores: Array<{ __typename?: 'ConsignmentCurationStore', consignmentRegistrationStoreID: any, branchID: any, branchName: string, distanceKm?: number | null, ready: boolean, notReadyReason?: string | null, approvedProductCount: number, result?: ConsignmentCurationStoreResult | null, commissionType?: ConsignmentCurationCommissionType | null, commissionPct?: number | null }> } };

export type ConsignmentRegistrationShowFieldMutationVariables = Exact<{
  consignmentRegistrationID: Scalars['UUID']['input'];
  field: ConsignmentRegistrationSensitiveField;
}>;


export type ConsignmentRegistrationShowFieldMutation = { __typename?: 'Mutation', consignmentRegistrationShowField: string };

export type ConsignmentRegistrationShowFieldAllTeamsMutationVariables = Exact<{
  consignmentRegistrationID: Scalars['UUID']['input'];
  field: ConsignmentRegistrationSensitiveField;
}>;


export type ConsignmentRegistrationShowFieldAllTeamsMutation = { __typename?: 'Mutation', consignmentRegistrationShowFieldAllTeams: string };

export type ConsignmentRequestDetailQueryVariables = Exact<{
  consignmentRegistrationID: Scalars['UUID']['input'];
}>;


export type ConsignmentRequestDetailQuery = { __typename?: 'Query', consignmentRegistrationDetail: { __typename?: 'ConsignmentRegistrationDetail', consignmentRegistrationID: any, registrationNumber: string, viewMode: ConsignmentRegistrationViewMode, stage: ConsignmentRegistrationStage, primaryStatus: ConsignmentRequestPrimaryStatus, teamID: any, teamName: string, claimedByUserID?: any | null, claimedByUserName?: string | null, claimedByMe: boolean, isMyTeam: boolean, submittedAt: any, stageChangedAt: any, ageDays: number, inStageDays: number, reapplyFrom?: string | null, stageDeadlineDate?: string | null, vendor: { __typename?: 'ConsignmentRegistrationVendor', businessName: string, entityType: string, brandName?: string | null, provinceName: string, cityName: string, districtName?: string | null, addressLine?: string | null, phoneNumberMasked?: string | null, targetStoreCount: number, productCount: number, brandOwnership: string, email?: string | null, instagram?: string | null, tiktok?: string | null, heardFrom?: string | null, heardFromDetail?: string | null }, routing?: { __typename?: 'ConsignmentRegistrationRouting', nearestStoreName?: string | null, nearestDistanceKm?: number | null, reason: ConsignmentRegistrationRoutingReason, routedFromCityCentroid: boolean } | null, flags?: Array<{ __typename?: 'ConsignmentRegistrationFlag', kind: ConsignmentRegistrationFlagKind, refConsignmentRegistrationID?: any | null, refRegistrationNumber?: string | null, refStage?: ConsignmentRegistrationStage | null, refDate?: string | null, refVendorCode?: string | null, refVendorName?: string | null }> | null } };

export type ConsignmentRequestDetailAllTeamsQueryVariables = Exact<{
  consignmentRegistrationID: Scalars['UUID']['input'];
}>;


export type ConsignmentRequestDetailAllTeamsQuery = { __typename?: 'Query', consignmentRegistrationDetailAllTeams: { __typename?: 'ConsignmentRegistrationDetail', consignmentRegistrationID: any, registrationNumber: string, viewMode: ConsignmentRegistrationViewMode, stage: ConsignmentRegistrationStage, primaryStatus: ConsignmentRequestPrimaryStatus, teamID: any, teamName: string, claimedByUserID?: any | null, claimedByUserName?: string | null, claimedByMe: boolean, isMyTeam: boolean, submittedAt: any, stageChangedAt: any, ageDays: number, inStageDays: number, reapplyFrom?: string | null, stageDeadlineDate?: string | null, vendor: { __typename?: 'ConsignmentRegistrationVendor', businessName: string, entityType: string, brandName?: string | null, provinceName: string, cityName: string, districtName?: string | null, addressLine?: string | null, phoneNumberMasked?: string | null, targetStoreCount: number, productCount: number, brandOwnership: string, email?: string | null, instagram?: string | null, tiktok?: string | null, heardFrom?: string | null, heardFromDetail?: string | null }, routing?: { __typename?: 'ConsignmentRegistrationRouting', nearestStoreName?: string | null, nearestDistanceKm?: number | null, reason: ConsignmentRegistrationRoutingReason, routedFromCityCentroid: boolean } | null, flags?: Array<{ __typename?: 'ConsignmentRegistrationFlag', kind: ConsignmentRegistrationFlagKind, refConsignmentRegistrationID?: any | null, refRegistrationNumber?: string | null, refStage?: ConsignmentRegistrationStage | null, refDate?: string | null, refVendorCode?: string | null, refVendorName?: string | null }> | null } };

export type ConsignmentRequestDetailFieldsFragment = { __typename?: 'ConsignmentRegistrationDetail', consignmentRegistrationID: any, registrationNumber: string, viewMode: ConsignmentRegistrationViewMode, stage: ConsignmentRegistrationStage, primaryStatus: ConsignmentRequestPrimaryStatus, teamID: any, teamName: string, claimedByUserID?: any | null, claimedByUserName?: string | null, claimedByMe: boolean, isMyTeam: boolean, submittedAt: any, stageChangedAt: any, ageDays: number, inStageDays: number, reapplyFrom?: string | null, stageDeadlineDate?: string | null, vendor: { __typename?: 'ConsignmentRegistrationVendor', businessName: string, entityType: string, brandName?: string | null, provinceName: string, cityName: string, districtName?: string | null, addressLine?: string | null, phoneNumberMasked?: string | null, targetStoreCount: number, productCount: number, brandOwnership: string, email?: string | null, instagram?: string | null, tiktok?: string | null, heardFrom?: string | null, heardFromDetail?: string | null }, routing?: { __typename?: 'ConsignmentRegistrationRouting', nearestStoreName?: string | null, nearestDistanceKm?: number | null, reason: ConsignmentRegistrationRoutingReason, routedFromCityCentroid: boolean } | null, flags?: Array<{ __typename?: 'ConsignmentRegistrationFlag', kind: ConsignmentRegistrationFlagKind, refConsignmentRegistrationID?: any | null, refRegistrationNumber?: string | null, refStage?: ConsignmentRegistrationStage | null, refDate?: string | null, refVendorCode?: string | null, refVendorName?: string | null }> | null };

export type ConsignmentRequestListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentRegistrationQueueQopInput>;
}>;


export type ConsignmentRequestListQuery = { __typename?: 'Query', consignmentRegistrationQueue: { __typename?: 'ConsignmentRegistrationQueuePaged', items?: Array<{ __typename?: 'ConsignmentRegistrationQueueItem', consignmentRegistrationID: any, registrationNumber: string, vendorName: string, teamID: any, teamName: string, ageDays: number, inStageDays: number, claimedByUserID?: any | null, claimedByUserName?: string | null, claimedByMe: boolean, isMyTeam: boolean, stage: ConsignmentRegistrationStage, primaryStatus: ConsignmentRequestPrimaryStatus, routing?: { __typename?: 'ConsignmentRegistrationRouting', nearestStoreName?: string | null, nearestDistanceKm?: number | null, routedFromCityCentroid: boolean } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ConsignmentRequestListAllTeamsQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentRegistrationQueueQopInput>;
}>;


export type ConsignmentRequestListAllTeamsQuery = { __typename?: 'Query', consignmentRegistrationQueueAllTeams: { __typename?: 'ConsignmentRegistrationQueuePaged', items?: Array<{ __typename?: 'ConsignmentRegistrationQueueItem', consignmentRegistrationID: any, registrationNumber: string, vendorName: string, teamID: any, teamName: string, ageDays: number, inStageDays: number, claimedByUserID?: any | null, claimedByUserName?: string | null, claimedByMe: boolean, isMyTeam: boolean, stage: ConsignmentRegistrationStage, primaryStatus: ConsignmentRequestPrimaryStatus, routing?: { __typename?: 'ConsignmentRegistrationRouting', nearestStoreName?: string | null, nearestDistanceKm?: number | null, routedFromCityCentroid: boolean } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ConsignmentRequestListChipCountFieldsFragment = { __typename?: 'ConsignmentRegistrationQueueChipCounts', all: number, unclaimed: number, claimedByMe: number, waitingOnTeam: number, waitingOnVendor: number, activationNotFinished: number, done: number };

export type ConsignmentRequestListChipCountsQueryVariables = Exact<{
  teamID?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ConsignmentRequestListChipCountsQuery = { __typename?: 'Query', consignmentRegistrationQueueChipCounts: { __typename?: 'ConsignmentRegistrationQueueChipCounts', all: number, unclaimed: number, claimedByMe: number, waitingOnTeam: number, waitingOnVendor: number, activationNotFinished: number, done: number } };

export type ConsignmentRequestListChipCountsAllTeamsQueryVariables = Exact<{
  teamID?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ConsignmentRequestListChipCountsAllTeamsQuery = { __typename?: 'Query', consignmentRegistrationQueueChipCountsAllTeams: { __typename?: 'ConsignmentRegistrationQueueChipCounts', all: number, unclaimed: number, claimedByMe: number, waitingOnTeam: number, waitingOnVendor: number, activationNotFinished: number, done: number } };

export type ConsignmentRequestListItemFieldsFragment = { __typename?: 'ConsignmentRegistrationQueueItem', consignmentRegistrationID: any, registrationNumber: string, vendorName: string, teamID: any, teamName: string, ageDays: number, inStageDays: number, claimedByUserID?: any | null, claimedByUserName?: string | null, claimedByMe: boolean, isMyTeam: boolean, stage: ConsignmentRegistrationStage, primaryStatus: ConsignmentRequestPrimaryStatus, routing?: { __typename?: 'ConsignmentRegistrationRouting', nearestStoreName?: string | null, nearestDistanceKm?: number | null, routedFromCityCentroid: boolean } | null };

export type ConsignmentRegistrationAccessUpdateMutationVariables = Exact<{
  input: ConsignmentRegistrationAccessUpdateInput;
}>;


export type ConsignmentRegistrationAccessUpdateMutation = { __typename?: 'Mutation', consignmentRegistrationAccessUpdate: { __typename?: 'ConsignmentSetupRegistrationUpdateResult', changed: boolean, registration: { __typename?: 'ConsignmentSetupRegistration', productsPerRegistration: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, reapplyWaitDays: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, resellerContactWa: { __typename?: 'ConsignmentSetupContactSetting', settingKey: string, value?: string | null, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, partnerSupportContactWa: { __typename?: 'ConsignmentSetupContactSetting', settingKey: string, value?: string | null, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, registrationAccess: { __typename?: 'ConsignmentRegistrationAccessSetting', settingKey: string, value?: ConsignmentRegistrationAccess | null, effectiveValue: ConsignmentRegistrationAccess, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null } } } };

export type ConsignmentSetupContactSettingFieldsFragment = { __typename?: 'ConsignmentSetupContactSetting', settingKey: string, value?: string | null, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null };

export type ConsignmentSetupContractQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsignmentSetupContractQuery = { __typename?: 'Query', consignmentSetupContract: { __typename?: 'ConsignmentSetupContract', completeDataDays: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, defaultAgreementMonths: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, signContractDays: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null } } };

export type ConsignmentSetupContractFieldsFragment = { __typename?: 'ConsignmentSetupContract', completeDataDays: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, defaultAgreementMonths: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, signContractDays: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null } };

export type ConsignmentSetupContractUpdateMutationVariables = Exact<{
  input: ConsignmentSetupContractUpdateInput;
}>;


export type ConsignmentSetupContractUpdateMutation = { __typename?: 'Mutation', consignmentSetupContractUpdate: { __typename?: 'ConsignmentSetupContractUpdateResult', changed: boolean, contract: { __typename?: 'ConsignmentSetupContract', completeDataDays: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, defaultAgreementMonths: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, signContractDays: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null } } } };

export type ConsignmentSetupIntSettingFieldsFragment = { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null };

export type ConsignmentSetupRegistrationQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsignmentSetupRegistrationQuery = { __typename?: 'Query', consignmentSetupRegistration: { __typename?: 'ConsignmentSetupRegistration', productsPerRegistration: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, reapplyWaitDays: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, resellerContactWa: { __typename?: 'ConsignmentSetupContactSetting', settingKey: string, value?: string | null, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, partnerSupportContactWa: { __typename?: 'ConsignmentSetupContactSetting', settingKey: string, value?: string | null, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, registrationAccess: { __typename?: 'ConsignmentRegistrationAccessSetting', settingKey: string, value?: ConsignmentRegistrationAccess | null, effectiveValue: ConsignmentRegistrationAccess, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null } } };

export type ConsignmentSetupRegistrationFieldsFragment = { __typename?: 'ConsignmentSetupRegistration', productsPerRegistration: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, reapplyWaitDays: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, resellerContactWa: { __typename?: 'ConsignmentSetupContactSetting', settingKey: string, value?: string | null, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, partnerSupportContactWa: { __typename?: 'ConsignmentSetupContactSetting', settingKey: string, value?: string | null, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, registrationAccess: { __typename?: 'ConsignmentRegistrationAccessSetting', settingKey: string, value?: ConsignmentRegistrationAccess | null, effectiveValue: ConsignmentRegistrationAccess, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null } };

export type ConsignmentSetupRegistrationUpdateMutationVariables = Exact<{
  input: ConsignmentSetupRegistrationUpdateInput;
}>;


export type ConsignmentSetupRegistrationUpdateMutation = { __typename?: 'Mutation', consignmentSetupRegistrationUpdate: { __typename?: 'ConsignmentSetupRegistrationUpdateResult', changed: boolean, registration: { __typename?: 'ConsignmentSetupRegistration', productsPerRegistration: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, reapplyWaitDays: { __typename?: 'ConsignmentSetupIntSetting', settingKey: string, value?: number | null, min: number, max: number, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, resellerContactWa: { __typename?: 'ConsignmentSetupContactSetting', settingKey: string, value?: string | null, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, partnerSupportContactWa: { __typename?: 'ConsignmentSetupContactSetting', settingKey: string, value?: string | null, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null }, registrationAccess: { __typename?: 'ConsignmentRegistrationAccessSetting', settingKey: string, value?: ConsignmentRegistrationAccess | null, effectiveValue: ConsignmentRegistrationAccess, version?: any | null, updatedAt?: any | null, updatedByUserName?: string | null } } } };

export type ConsignmentVendorApplicationInviteCreateMutationVariables = Exact<{
  input: ConsignmentPilotInviteCreateInput;
}>;


export type ConsignmentVendorApplicationInviteCreateMutation = { __typename?: 'Mutation', consignmentPilotInviteCreate: { __typename?: 'ConsignmentPilotInvite', consignmentPilotInviteID: any, phoneNumberMasked: string, businessName: string, source: ConsignmentPilotInviteSource, status: ConsignmentPilotInviteStatus, registrationNumber?: string | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, createdByUserName?: string | null } } };

export type ConsignmentVendorApplicationInviteDeleteMutationVariables = Exact<{
  consignmentPilotInviteID: Scalars['UUID']['input'];
}>;


export type ConsignmentVendorApplicationInviteDeleteMutation = { __typename?: 'Mutation', consignmentPilotInviteDelete: boolean };

export type ConsignmentVendorApplicationInviteFieldsFragment = { __typename?: 'ConsignmentPilotInvite', consignmentPilotInviteID: any, phoneNumberMasked: string, businessName: string, source: ConsignmentPilotInviteSource, status: ConsignmentPilotInviteStatus, registrationNumber?: string | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, createdByUserName?: string | null } };

export type ConsignmentVendorApplicationInviteImportMutationVariables = Exact<{
  input: ConsignmentPilotInviteImportInput;
}>;


export type ConsignmentVendorApplicationInviteImportMutation = { __typename?: 'Mutation', consignmentPilotInviteImport: { __typename?: 'ConsignmentPilotInviteImportResult', importedRows: number, skippedRows: number, rows: Array<{ __typename?: 'ConsignmentPilotInviteImportRow', rowNumber: number, phoneNumberMasked?: string | null, businessName: string, status: ConsignmentPilotInviteImportRowStatus, reasons: Array<string> }> } };

export type ConsignmentVendorApplicationInviteImportPreviewQueryVariables = Exact<{
  input: ConsignmentPilotInviteImportInput;
}>;


export type ConsignmentVendorApplicationInviteImportPreviewQuery = { __typename?: 'Query', consignmentPilotInviteImportPreview: { __typename?: 'ConsignmentPilotInviteImportPreview', totalRows: number, validRows: number, invalidRows: number, rows: Array<{ __typename?: 'ConsignmentPilotInviteImportRow', rowNumber: number, phoneNumberMasked?: string | null, businessName: string, status: ConsignmentPilotInviteImportRowStatus, reasons: Array<string> }> } };

export type ConsignmentVendorApplicationInviteImportRowFieldsFragment = { __typename?: 'ConsignmentPilotInviteImportRow', rowNumber: number, phoneNumberMasked?: string | null, businessName: string, status: ConsignmentPilotInviteImportRowStatus, reasons: Array<string> };

export type ConsignmentVendorApplicationInviteListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentPilotInviteQopInput>;
}>;


export type ConsignmentVendorApplicationInviteListQuery = { __typename?: 'Query', consignmentPilotInvites: { __typename?: 'ConsignmentPilotInvitePaged', items?: Array<{ __typename?: 'ConsignmentPilotInvite', consignmentPilotInviteID: any, phoneNumberMasked: string, businessName: string, source: ConsignmentPilotInviteSource, status: ConsignmentPilotInviteStatus, registrationNumber?: string | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, createdByUserName?: string | null } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, nextCursor?: string | null } } };
